<template>
  <div :class="{'editing':editEnabled}">
    <div :class="['map-box', showMapMobile ? 'showMapBox' : '']">
      <div class="map-here" id="mapHere"></div>

      <div class="legend" v-if="rsvpDetails.tripInfo.status !== 'canceled'">
        <ul>
          <li>
            <div class="icon pickup"></div>
            <span>Pickup</span>
          </li>
          <li>
            <div class="icon extra-stop"></div>
            <span>Extra Stop</span>
          </li>
          <li>
            <div class="icon dropoff"></div>
            <span>Dropoff</span>
          </li>
          <li>
            <div class="icon ontheway"></div>
            <span>On the way</span>
          </li>
          <li>
            <div class="icon arrived"></div>
            <span>Arrived / On Board</span>
          </li>
          <li>
            <div class="icon completed"></div>
            <span>Completed</span>
          </li>
        </ul>
      </div>

      <transition name="show-up">
        <div class="cancel-data-box" v-if="rsvpDetails.tripInfo.status === 'canceled'">
          <ul>
            <li v-for="data in cancelData">
              <label><div :class="['icon', data.status]"></div>{{ data.label }}</label>
              <span>{{ data.date }}</span>
            </li>
            <li>
              <label><div class="icon canceled"></div>Cancelled</label>
              <span>{{ rsvpDetails.tripInfo.canceled }}</span>
            </li>
          </ul>
        </div>
      </transition>
    </div>

    <div class="render-loader" v-show="mapLoader.show">
      <div class="map-loading">
        <i class="fas fa-circle-notch fa-spin"></i>
        <span>{{ mapLoader.label }}</span>
      </div>
    </div>

    <div class="left-panel">
      <div class="heading">
        <div class="row" style="max-width: 100%">
          <div :class="['columns small-12', rsvpStatus.class === 'canceled' ? 'medium-12' : 'medium-8']">
            <span class="label" v-if="!isNewRsvp">
              {{ $t('rsvpDetails.rsvpId', {id: $route.params.id}) }}
              <span class="mtech-id" v-if="rsvpDetails.tripInfo.isMtech && (mtechData.loading || mtechData.id)">
                MTECH 
                <span v-if="!mtechData.loading">#{{mtechData.id}}</span>
                <i class="fa fa-spinner fa-spin fa-fw" v-else></i>
              </span>
              <a v-bind:href="'/#/package/' + isPackage" v-show="!!isPackage" target="_blank">
                <i class="fa fa-cube"></i>
              </a>
              <a href="#" v-show="rsvpDetails.tripInfo.wheelchair"><i class="fas fa-wheelchair"></i></a>
              <a href="#" v-show="rsvpDetails.tripInfo.serviceDog"><i class="fas fa-dog"></i></a>
              <span class="lr-tooltip" v-if="rsvpDetails.tripInfo.optinShared.isOptinShared">
                <img src="../../assets/img/shared-ride-blue.png" class="optin-icon" />
                <div class="tp-desc">Opted in to a shared service</div>
              </span>
            </span>
            <span class="label" v-else style="padding-top:5px;">NEW RESERVATION</span>
            <span :class="['status', rsvpStatus.class, dispatchStatusX]" v-if="!isNewRsvp" :key="$route.params.id">{{ rsvpStatus.label }}</span>
            <span class="cxl-reason" v-if="rsvpStatus.class === 'canceled'">{{ rsvpDetails.tripInfo.paxReason }}</span>
            <a class="track-link" target="_blank" v-if="['onboard', 'dispatched'].indexOf(rsvpStatus.class) > -1" :href="trackLink">&lt;Track Link&gt;</a>
            <a class="track-link lyft-link" target="_blank" v-if="lyft.show && lyft.routeUrl" :href="lyft.routeUrl">&lt;LYFT Track Link&gt;</a>
          </div>
          <div class="columns medium-4 small-12 edit-btn-div">
            <a v-bind:class="['button cta small edit', editEnabled ? 'error' : 'success', rsvpEditIsSaving || rsvpStatus.class === '' ? 'disabled' : '']"
              @click="toggleEdit" v-if="rsvpStatus.class !== 'complete' && rsvpStatus.class !== 'canceled' && rsvpStatus.class !== 'auto-dispatch' && !isNewRsvp && editAccess && !isAsapRsvp && rsvpStatus.class !== 'open-credit' && !isTerminal && !rsvpDetails.tripInfo.isMtech && tripInfo.serviceType.label !== 'Lyft'">
              <b v-show="!editEnabled">{{ $t('rsvpDetails.editRsvp') }}</b>
              <b v-show="editEnabled">{{ $t('rsvpDetails.cancelEdit') }}</b>
            </a>
          </div>
        </div>
      </div>
      <ul class="tab" v-if="!isNewRsvp">
        <li :class="{'grow': true, 'active':activeTab.left === 0}"
          @click="switchTab('left', 0)">
          {{ $t('rsvpDetails.tabLabel.basicInfo') }}
        </li>
        <li :class="{'grow': true, 'active':activeTab.left === 1, 'disabled':editEnabled}"
          @click="switchTab('left', 1)">
          {{ $t('rsvpDetails.tabLabel.transactions') }}
        </li>
        <li :class="{'grow': true, 'active':activeTab.left === 2, 'disabled':editEnabled}"
          @click="switchTab('left', 2)">
          {{ $t('rsvpDetails.tabLabel.notes') }}
        </li>
      </ul>

      <div :class="{'tab-contents':true, 'transaction-tab':activeTab.left == 1}">
        <div :class="{'tab-content':true, 'active':activeTab.left == 0}">
          <edit-reservation v-show="editEnabled" ref="edit"></edit-reservation>
          <basic-information v-show="!editEnabled"></basic-information>
        </div>
        <div :class="{'tab-content no-H-padding':true, 'active':activeTab.left == 1}">
          <transactions :rsvpId="$route.params.id" ref="transactions"></transactions>
        </div>
        <div :class="{'tab-content no-H-padding':true, 'active':activeTab.left == 2}">
          <notes :rsvpId="$route.params.id" ref="notes"></notes>
        </div>
      </div>

      <div class="fixed-bottom" v-show="showButtons">
        <a class="button cta error small" @click="cancelRsvp"
          v-if="activeTab.left !== 2 && showCancelButton && !editEnabled">
          {{ $t('rsvpDetails.cancelRsvp') }}
        </a>
        <a :class="['button cta small', hasRSVPControl ? 'success' : 'secondary disabled']" href="javascript:;" @click="markAsComplete"
          v-if="activeTab.left !== 2 && rsvpStatus.class !== 'complete' && rsvpStatus.class !== 'canceled' && !editEnabled && rsvpStatus.class !== 'open-credit'">
          {{ $t('rsvpDetails.markComplete') }}
        </a>
        <a v-if="showRTGButton && activeTab.left !== 2 && !rsvpDetails.tripInfo.isMtech"
          class="rtg button cta small" @click="showRTG($route.params.id)">Ready to go</a>
        <a class="button cta success small" @click="AddNotes"
          v-if="activeTab.left === 2 && noteAccess">
          {{ $t('rsvpDetails.addNote') }}
        </a>

        <a :class="{'button cta error small right':true, 'disabled':rsvpEditIsSaving}"
          @click="toggleEdit" v-if="editEnabled && !isNewRsvp">
          {{ $t('rsvpDetails.cancelEdit') }}
        </a>
        <a :class="{'button cta success small right':true, 'disabled':rsvpEditIsSaving, 'create':isNewRsvp}"
          @click="editRsvpSave" v-if="editEnabled">
          <span v-if="!isNewRsvp">{{ $t('rsvpDetails.saveChanges') }}</span>
          <span v-else>Create</span>
        </a>
      </div>

    </div>
    <div class="toggle-mobile" @click="showMapMobile = !showMapMobile">
      <span v-if="!showMapMobile">Show Map <i class="fa fa-chevron-up"></i></span>
      <span v-else>Hide Map <i class="fa fa-chevron-down"></i></span>  
    </div>

    <transition name="fade" mode="out-in">
      <a :class="{'logs-toggle':true, on: showRightPanel}" v-show="showIconLog" @click="toggleRightPanel"><i :class="iconToggleRightPanel"></i></a>
    </transition>
    <div :class="{'right-panel': true, hide: showRightPanel}">
      <div class="heading">{{ $t('rsvpDetails.history') }}</div>

      <ul class="tab" v-show="dispatches > 0">
        <li :class="{'grow':true, 'active':activeTab.right === 0}" @click="switchTab('right', 0)">
          {{ $t('rsvpDetails.tabLabel.actionLogs') }}
        </li>
        <li :class="{'grow':true, 'active':activeTab.right === 1}" @click="switchTab('right', 1)">
          {{ $t('rsvpDetails.tabLabel.dispatchLogs') }}
        </li>
      </ul>

      <div class="tab-contents">
        <div :class="{'tab-content':true, 'active':activeTab.right == 0}">
          <action-logs :rsvpId="$route.params.id" ref="actionLogs"></action-logs>
        </div>
        <div :class="{'tab-content dispatch-log':true, 'active':activeTab.right == 1}">
          <dispatch-logs :rsvpId="$route.params.id"></dispatch-logs>
        </div>
      </div>

    </div>

    <loading-modal :showModal="(loading && !rsvpAction.show) || servicesLoading" modalMessage="Loading"></loading-modal>

    <loading-modal :showModal="rsvpEditIsSaving"
      :modalMessage="$t('rsvpDetails.edit.updatingReservation')"></loading-modal>

    <loading-modal :showModal="createRsvpLoading"
      modalMessage="Creating reservation..."></loading-modal>

    <div :class="{'modal':true, 'show':showBreakdownPayment}">
      <div class="bg-overlay" @click="closeBreakdown"></div>
      <div class="modal-content breakdown">
        <div class="head d-flex justify-space-between align-center">
          <span>{{ $t('rsvpDetails.tripInformation.paymentBreakdown') }}</span>
          <span class="op-link" @click="showOverrideModal" v-if="allowOverridePayment">Override Payment</span>
        </div>
        <div class="item">
          <span class="label">{{ $t('rsvpDetails.tripInformation.fareAmount') }}</span>
          <span class="value">
            <span v-if="!useLocalCurrency">${{ driverPaymentBreakdown.fare }}</span>
            <span v-else>{{ applyCurrency(driverPaymentBreakdown.fare) }}</span>
          </span>
        </div>
        <div class="item">
          <span class="label">{{ $t('rsvpDetails.tripInformation.bonus') }}</span>
          <span class="value">
            <span v-if="!useLocalCurrency">${{ driverPaymentBreakdown.bonus }}</span>
            <span v-else>{{ applyCurrency(driverPaymentBreakdown.bonus) }}</span>
          </span>
        </div>
        <div class="item">
          <span class="label">Fuel Surcharge</span>
          <span class="value">
            <span v-if="!useLocalCurrency">${{ driverPaymentBreakdown.gasFee }}</span>
            <span v-else>{{ xcurrency.format({code: currency.currency, val: currency.gasFee.toFixed(2)}) }}</span>
          </span>
        </div>
        <div class="item">
          <span class="label">{{ $t('rsvpDetails.tripInformation.tip') }}</span>
          <span class="value">
            <span v-if="!useLocalCurrency">${{ driverPaymentBreakdown.tip }}</span>
            <span v-else>{{ xcurrency.format({code: currency.currency, val: currency.tipAmount.toFixed(2)}) }}</span>
          </span>
        </div>
        <div class="item">
          <span class="label">{{ $t('rsvpDetails.tripInformation.pickupFee') }}</span>
          <span class="value">
            <span v-if="!useLocalCurrency">${{ driverPaymentBreakdown.pickupFee }}</span>
            <span v-else>{{ xcurrency.format({code: currency.currency, val: currency.pickupFee.toFixed(2)}) }}</span>
          </span>
        </div>
        <div class="item">
          <span class="label">{{ $t('rsvpDetails.tripInformation.paymentBonus') }}</span>
          <span class="value">
            <span v-if="!useLocalCurrency">${{ driverPaymentBreakdown.paymentBonus }}</span>
            <span v-else>{{ applyCurrency(driverPaymentBreakdown.paymentBonus) }}</span>
          </span>
        </div>

        <a href="javascript:;" class="button cta block small" @click="closeBreakdown">
          {{ $t('rsvpDetails.tripInformation.close') }}
        </a>
      </div>
    </div>

    <div :class="{'modal':true, 'show':overrideModal.show}">
      <div class="bg-overlay" @click="overrideModal.show = false"></div>
      <div class="modal-content breakdown">
        <div class="head">Driver Payment Override</div>
        <div class="dpo-field">
          <span>$</span>
          <input type="number" placeholder="Amount..." v-model="overrideModal.value" step=".1" min="0" onkeydown="if(event.key==='-'){event.preventDefault();}"
  onpaste="e => e.preventDefault()"/>

        </div>
        <div class="d-flex justify-space-between" style="gap: 20px">
          <a href="javascript:;" class="button cta block small secondary" @click="overrideModal.show = false">
            Cancel
          </a>
          <a href="javascript:;" class="button cta block small" @click="submitDriverPaymentOverride">
            Submit
          </a>
        </div>
      </div>
    </div>

    <div :class="{'modal':true, 'show':showFlightStatus}">
      <div class="bg-overlay" @click="closeFlightStatus"></div>
      <div class="modal-content flightStatusModal">
        <div class="loading" v-show="flightStatusLoading">
          <i class="fa fa-circle-notch fa-spin"></i>
          {{ $t('rsvpDetails.flightStatus.loading') }}
        </div>
        <div class="flight-error" v-show="!flightStatusLoading && flightStatusError">
          <i class="fa fa-frown fa-4x"></i>
          <span class="title">Oops!</span>
          <span class="body">{{ $t('rsvpDetails.flightStatus.error') }}</span>
        </div>
        <div v-show="!flightStatusLoading && !flightStatusError">
          <span class="label">{{ $t('rsvpDetails.flightStatus.status') }}</span>
          <span class="value">{{ flightStatus.status }}</span>
          <span class="label">{{ $t('rsvpDetails.flightStatus.departureAirport') }}</span>
          <span class="value">{{ flightStatus.departureAirport }}</span>
          <span class="label">{{ $t('rsvpDetails.flightStatus.arrivalAirport') }}</span>
          <span class="value">{{ flightStatus.arrivalAirport }}</span>
          <span class="label" v-if="!isAirportDropoff">{{ $t('rsvpDetails.flightStatus.arrivalDate') }}</span>
          <span class="label" v-if="isAirportDropoff">{{ $t('rsvpDetails.flightStatus.departureDate') }}</span>
          <span class="value">{{ flightStatus.arrivalTime }}</span>
        </div>

        <a href="javascript:;" class="button cta warning block small try-again"
          @click="updateFlightStatus" v-show="flightStatusError">
          {{ $t('rsvpDetails.flightStatus.tryAgain') }}
        </a>
        <a href="javascript:;" class="button cta block small" @click="closeFlightStatus">
          {{ $t('rsvpDetails.tripInformation.close') }}
        </a>
      </div>
    </div>

    <div :class="{'modal':true, 'show':sendEmail.show}">
      <div class="bg-overlay" @click="closeEmailResult"></div>
      <div class="modal-content email-result">
        <p>{{ sendEmail.message }}</p>

        <a class="button cta warning block small" @click="closeEmailResult">
          {{ $t('rsvpDetails.close') }}
        </a>
      </div>
    </div>

    <div :class="{'modal':true, 'show':sendNoShow.showModal}">
      <div class="bg-overlay" @click="closeNoShowResult"></div>
      <div class="modal-content email-result">
        <div v-if="!!sendNoShow.message">
          <p>{{ sendNoShow.message }}</p>

          <a class="button cta warning block small" @click="closeNoShowResult">
            {{ $t('rsvpDetails.close') }}
          </a>
        </div>
        <div v-else>
          <span class="header">{{ $t('rsvpDetails.noShow.header') }}</span>
          <span class="body" v-html="noShowMessage()"></span>

          <a :class="{'button cta warning block small':true, 'disabled':sendNoShow.loading}"
            @click="applyNoShow">
            <span v-if="!sendNoShow.loading">{{ $t('rsvpDetails.noShow.yes') }}</span>
            <span v-else>
              <i class="fa fa-spinner fa-spin fa-fw"></i>
              {{ $t('rsvpDetails.noShow.loading') }}
            </span>
          </a>
          <a class="cancel" @click="closeNoShowResult">{{ $t('rsvpDetails.noShow.cancel') }}</a>
        </div>
      </div>
    </div>

    <div v-bind:class="{'release-modal': true, show: showReleaseModal}">
      <div class="release-modal-container" @click="$store.commit('rsvpDetails/hideReleaseConfirmation')">
        <div class="release-modal-content" @click.stop>
          <div class="confirm-release" v-show="!releasingDriver">
            <div class="title">
              <span v-if="!release.loading">CONFIRM THE RELEASE</span>
              <span v-else-if="release.error.show">ERROR</span>
              <span v-else>Loading...</span>
            </div>
            <!-- <transition name="down-scale"> -->
            <div v-if="release.loading && !release.error.show" class="loading">
              <i class="fa fa-spinner fa-spin fa-fw fa-5x"></i>
              <div>Please wait...</div>
            </div>
            <!-- </transition> -->
            <transition name="slide-up">
              <div v-if="release.error.show" class="error">
                <i class="fas fa-exclamation-triangle fa-fw fa-5x"></i>
                <div>{{ release.error.message }}</div>
              </div>
            </transition>
            <transition name="slide-up">
              <div v-if="release.showContent && !release.error.show">
                <div class="message">
                  Are you sure you want to un-assign this reservation from
                  <a :href="'/#/provider/' + $store.state.rsvpDetails.basicInfo.driverInfo.id" target="_blank">{{ $store.state.rsvpDetails.basicInfo.driverInfo.firstName }} {{ $store.state.rsvpDetails.basicInfo.driverInfo.lastName }}</a>?
                </div>
                <div class="fee" v-if="release.fee > 0">
                  <p>The driver will have to pay an unassign fee of <b>${{ (release.fee).toFixed(2) }}</b>. Do you want to charge the unassign fee?</p>
                  <label>
                    <input type="radio" name="release" value="1" v-model="release.charge"> Yes
                  </label>
                  <label>
                    <input type="radio" name="release" value="0" v-model="release.charge"> No
                  </label>
                  <div class="clear"></div>
                </div>
                <div class="sub-message">
                  If you are un-assigning the driver in order to edit this reservation, make sure that you <strong>assign it back to the same driver</strong>. Otherwise, make sure that you <strong>find another driver to cover this reservation</strong> or
                  <strong>push it back again to the pool</strong>.
                </div>
                <div class="row controls">
                  <div class="small-6 columns padding-R">
                    <a href="javascript:;" @click="$store.commit('rsvpDetails/hideReleaseConfirmation')"
                       class="button cta block small">NO</a>
                  </div>
                  <div class="small-6 columns padding-L">
                    <a href="javascript:;" class="button cta block small warning" @click="releaseDriver">YES</a>
                  </div>
                </div>
              </div>
            </transition>
          </div>
          <div class="releasing" v-show="releasingDriver">
            <i v-bind:class="{
              'fas fa-circle-notch fa-spin': !releaseSuccess,
              'fas fa-check-circle': releaseSuccess,
              'fa-fw fa-2x': true,
              success: releaseSuccess
            }"></i>
            <div class="message" v-show="!releaseSuccess">Un-assigning driver from this reservation...</div>
            <div class="message" v-show="releaseSuccess">Successfully un-assigned driver from the reservation.</div>
          </div>
        </div>
      </div>
    </div>

    <div :class="{'modal':true, 'show':rsvpAction.show}">
      <div class="bg-overlay" @click="closeActionModal"></div>
      <div class="modal-content emailResult">
        <p v-html="rsvpAction.message"></p>

        <a class="button cta warning block small" @click="closeActionModal">
          {{ $t('rsvpDetails.close') }}
        </a>
      </div>
    </div>

    <div :class="{'modal':true, 'show':rsvpEditSubmit.show}">
      <div class="bg-overlay" @click="closeEditSubmit"></div>
      <div class="modal-content emailResult">
        <p v-html="rsvpEditSubmit.message"></p>

        <a class="button cta warning block small" @click="closeEditSubmit(rsvpEditSubmit.status)">
          {{ $t('rsvpDetails.close') }}
        </a>
      </div>
    </div>

    <div :class="{'modal':true, 'show':suggestedTimeShow && !asapEnable}">
      <div class="bg-overlay" @click="closeSuggestedTime"></div>
      <div class="modal-content suggested-time-modal">
        <div class="title">Suggested Pickup Time</div>
        <p v-if="isAirportPickup">To make sure that the passenger can be picked up as soon as he/she arrives at the airport, the suggested pickup time is:</p>
        <p v-else>To make sure that the passenger doesn't miss his/her flight, the suggested pickup time is:</p>
        <span class="time">{{ suggestedTime() }}</span>
        <span class="button cta success block large" @click="applySuggestedTime">Yes, use the suggested pickup time.</span>
        <a class="keep" @click="closeSuggestedTime">No, I want to keep my pickup time.</a>
      </div>
    </div>

    <div :class="{'modal':true, 'show':showSelectUser}">
      <div class="bg-overlay" @click="closeShowSelectUser"></div>
      <div class="modal-content select-user">
        <div class="title">Select User</div>
        <div class="box">
          <div class="row">
            <div class="column small-9">
              <input type="text" class="search-input" v-model="users.input"
                placeholder="Type in customer name, email or mobile..."
                :disabled="users.loading" v-on:keypress.enter="searchUser">
            </div>
            <div class="column small-3 padding-L">
              <a class="button block" @click="searchUser">Search</a>
            </div>
          </div>
          <div class="box-list">
            <ul class="list">
              <li v-for="(user, index) in users.list" @click="selectUser(index)" :key="index">
                <div class="d-flex justify-space-between">
                  <div>
                    <span class="name">{{ user.firstName + ' ' + user.lastName }}</span>
                    <span class="email">{{ user.email }}</span>
                    <span class="mobile">+{{ user.countryCode }} {{ user.nationalNumber || user.mobile }}</span>
                  </div>
                  <div>
                    <span class="id">
                      <b>ID:</b> {{ user.id }}<br/>
                      <span class="is-d2d" v-if="user.isD2d">D2D</span>
                    </span>
                  </div>
                </div>
              </li>
            </ul>
            <transition name="appear">
              <div class="loader" v-show="users.loading">
                <div class="v-center">
                  <i class="fa fa-spinner fa-spin fa-fw fa-2x"></i>Loading...
                </div>
              </div>
            </transition>
          </div>
          <div class="row actions">
            <div class="column small-12"> <!-- padding-R -->
              <a class="button cta small error block btn-close" @click="closeShowSelectUser">Close</a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div :class="{'modal':true, 'show':showSelectCorporate}">
      <div class="bg-overlay" @click="closeShowSelectCorporate"></div>
      <div class="modal-content select-user">
        <div class="title">Select User</div>
        <div class="box">
          <div class="row">
            <div class="column small-9">
              <input type="text" class="search-input" v-model="corporate.input"
                placeholder="Type in customer name, email or mobile..."
                :disabled="corporate.loading" v-on:keypress.enter="searchCorporate">
            </div>
            <div class="column small-3 padding-L">
              <a class="button block" @click="searchCorporate">Search</a>
            </div>
          </div>
          <div class="box-list">
            <ul class="list">
              <li v-for="(users, index) in corporate.list" @click="selectCorporate(index)" :key="index" :class="{disabled:!users.active}">
                <span class="name">{{ users.firstName + ' ' + users.lastName }}</span><span class="id"><b>ID:</b> {{ users.id }}</span>
                <span class="email">{{ users.email }}</span>
                <span class="mobile">{{ users.displayMobile }}</span>
                <span class="status" v-if="!users.active">DISABLED</span>
              </li>
            </ul>
            <transition name="appear">
              <div class="loader" v-show="corporate.loading">
                <div class="v-center">
                  <i class="fa fa-spinner fa-spin fa-fw fa-2x"></i>Loading...
                </div>
              </div>
            </transition>
          </div>
          <div class="row actions">
            <div class="column small-12"> <!-- padding-R -->
              <a class="button cta small error block btn-close" @click="closeShowSelectCorporate">Close</a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div :class="{'modal':true, 'show':showAsapModal}">
      <div class="bg-overlay" @click="closeCreateError"></div>
      <div class="modal-content asap-modal">
        <div v-show="asapLoading && !asapNoDriver"> <!-- && !showFoundDriver -->
          <span class="fa-stack fa-3x asap-loader">
            <i class="fas fa-car fa-stack-1x"></i>
            <i class="fas fa-spinner fa-spin fa-stack-2x"></i>
          </span>
          <span class="looking-for">Looking for nearby drivers...</span>
          <span class="button cta warning cancel-asap small" @click="cancelAsap">Cancel</span>
        </div>

        <div v-show="asapDriverInfoLoading">
          <i class="fas fa-spinner fa-spin fa-3x"></i>
          <span class="looking-for">Getting driver info...</span>
        </div>

        <div v-show="!!asapDriverInfo.fullName" class="driver-info">
          <div class="title">Driver Info</div>
          <div class="info">
            <div class="img">
              <img :src="asapDriverInfo.profilePic" />
            </div>
            <div class="desc">
              <div class="rating"><i class="fas fa-star fa-fw"></i>{{ asapDriverInfo.rating }}</div>
              <div class="name">{{ asapDriverInfo.fullName }}</div>
              <div class="email">{{ asapDriverInfo.email }}</div>
            </div>
          </div>
          <div class="info">
            <div class="img">
              <img :src="asapDriverInfo.vehiclePick" />
            </div>
            <div class="desc">
              <div class="model">{{ asapDriverInfo.model }}</div>
              <div class="plate">{{ asapDriverInfo.plate }}</div>
            </div>
          </div>

          <span class="button cta success xsmall close-asap" @click="closeDoneAsap">Close</span>
        </div>

        <div v-show="asapNoDriver" class="no-driver">
          <i class="far fa-user-circle fa-4x"></i>
          <span class="message">No drivers available at this moment</span>
          <span class="button cta xsmall block change-service" @click="asapChangeService">Choose a Different Service</span>
          <span class="button cta warning xsmall block" @click="asapTryAgain">Try again</span>
        </div>
      </div>
    </div>

    <div :class="{'modal':true, 'show':createError.show}">
      <div class="bg-overlay" @click="closeCreateError"></div>
      <div class="modal-content create-error">
        <i class="fas fa-exclamation-circle fa-4x"></i>
        <div class="message">{{ createError.message }}</div>
        <span class="button cta warning xsmall block" @click="closeCreateError">Close</span>
      </div>
    </div>

    <div :class="{'modal':true, 'show':emailRecipientModal.show}">
      <div class="bg-overlay" @click="closeEmailRecipientModal"></div>
      <div class="modal-content select-email-recipient">
        <div class="title">{{ emailRecipientModal.title }}</div>
        <div class="box">
          <span class="label">Please select email recipient.</span>

          <ul>
            <li>
              <label @click="emailRecipientSelect('customer')">
                <input type="radio" name="emailRecipient" v-model="emailRecipientModal.selected" value="customer" />
                <span>{{ rsvpDetails.customerInfo.email }}</span>
              </label>
            </li>
            <li>
              <label @click="emailRecipientSelect('custom')">
                <input type="radio" name="emailRecipient" v-model="emailRecipientModal.selected" value="custom" />
                <input type="input" :class="{'has-error':!!customEmailFieldError}"
                  v-model="customEmailRecipient" @change="updateCustomEmailRecipient" />
              </label>
              <span class="has-error" v-if="customEmailFieldError">{{ customEmailFieldError }}</span>
            </li>
          </ul>

          <div class="row">
            <div class="column medium-6">
              <a :class="{'button cta small error block':true, 'disabled':customEmailLoading}" @click="closeEmailRecipientModal">Cancel</a>
            </div>
            <div class="column medium-6 padding-L">
              <a :class="{'button cta small success block':true, 'disabled':customEmailLoading}" @click="submitEmailRecipient">Send</a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div :class="['modal', {'show':optinModal}]" @click="optinModal = false">
      <div class="bg-overlay"></div>
      <div class="modal-content optin-modal" @click.stop>
        <label>Are you sure you want to convert this reservation?</label>
        <div class="d-flex justify-space-between">
          <a class="button cta small right" @click="optinModal = false">No</a>
          <a class="button cta success small right" @click="optinServiceConvert(tripInfo.optinShared.current)">Yes</a>
        </div>
      </div>
    </div>

    <ready-to-go-modal></ready-to-go-modal>
    <asap-modal @success="saveNotes"></asap-modal>

    <div style="display: none" v-if="renderFix">
      <here-info-bubble-car id="HCar" ref="HCar" :key="rsvpId + 'car'"></here-info-bubble-car>
      <here-info-bubble-pickup id="HPickup" ref="HPickup" :key="rsvpId + 'pickup'"></here-info-bubble-pickup>
      <here-info-bubble-dropoff id="HDropoff" ref="HDropoff" :key="rsvpId + 'dropoff'"></here-info-bubble-dropoff>
      <here-info-bubble-extra-stop v-for="i in totalExtraStops" :key="`${i-1}extraStop`"
        :id="`HExtraStop${i-1}`" :ref="`HExtraStop${i-1}`"
        :onEdit="editEnabled" :index="i - 1"
      ></here-info-bubble-extra-stop>
    </div>

    <notification-modal ref="notif"
      :isList="false" :provId="driverId"
      :removeAllActiveUserOption="true" :hideTargetOption="true"></notification-modal>
    <sms-modal ref="sms"
      :isList="false" :provId="driverId"
      :removeAllActiveUserOption="true" :hideTargetOption="true"></sms-modal>

    <cancel-upcoming-modal />
  </div>
</template>

<script>
/* global CONFIG */
import Vue from 'vue'
// import mapSettings from '@/values/map-settings'
import moment from 'moment'
import mapPins from '@/values/map-pin'
import ApiRsvp from '@/modules/api/reservations'
import ApiRsvpDispatch from '@/modules/api/reservation-details/dispatch'
// import ApiRsvpEdit from '@/modules/api/reservation-details/edit'
import ApiRsvpAdd from '@/modules/api/reservation-details/add'
import ApiLocation from '@/modules/api/location'
import editReservation from './Edit'
import basicInformation from './BasicInformation'
import transactions from './Transactions'
import systemLogs from './SystemLogs'
import dispatchLogs from './DispatchLogs'
import notes from './Notes'
import loadingModal from '../Partials/LoadingModal'
import featureToggle from '@/modules/api/featureToggle'
import driverRelease from '@/modules/api/driver-release'
import ReadyToGoModal from '@/components/Dispatch/ReadyToGoModal'
import actionLogs from './ActionLogs'
import ApiServices from '@/modules/api/services'
import AsapModal from './AsapModal'
import notificationModal from '../App/NotificationModal'
import smsModal from '../App/SMSModal'
import cancelUpcomingModal from '../App/CancelUpcomingModal'
import xcurrency from '@/modules/api/currency'

const request = require('browser-request')

export default {
  name: 'reservation-details',
  components: {
    basicInformation, editReservation, transactions, notes,
    systemLogs, loadingModal, ReadyToGoModal, actionLogs, AsapModal, dispatchLogs,
    notificationModal, smsModal, cancelUpcomingModal
  },
  data () {
    return {
      hereMaps: {
        map: {},
        platform: {},
        router: {},
        geocoder: {},
        directions: [],
        ui: {}
      },
      center: { lat: 33.942791, lng: -118.410042 }, // LAX coords
      rsvpInMap: null,
      driverInMap: null,
      mapLoader: {
        show: false,
        label: ''
      },
      infoWindows: [],
      activeTab: {
        left: 0,
        right: 0
      },
      loading: false,
      loadingMsg: 'Loading',
      flightStatusLoading: false,
      flightStatusError: false,
      releasingDriver: false,
      releaseSuccess: false,
      editEnabled: false,
      lastSeleted: '',
      release: {
        loading: false,
        showContent: false,
        fee: 0,
        charge: 1,
        error: {
          show: false,
          message: ''
        }
      },
      users: {
        input: '',
        list: [],
        loading: false,
        pageNum: 1,
        pageSize: 10
      },
      corporate: {
        input: '',
        list: [],
        loading: false,
        pageNum: 1,
        pageSize: 10
      },
      extraPins: [],
      extraPinsPath: [],
      completedPath: [],
      cancelData: [],
      showRightPanel: true,
      showIconLog: true,
      renderFix: true,
      isAsapRsvp: false,
      timerDelay: '',
      dispatchStatusX: '',
      customEmailRecipient: '',
      customEmailFieldError: '',
      customEmailLoading: false,
      noRelog: false,
      showMapMobile: false,
      lastRsvpId: '',
      mtechData: {
        id: '',
        loading: false
      },
      xcurrency: xcurrency,
      overrideModal: {
        show: false,
        value: ''
      }
    }
  },
  computed: {
    dispatches () { return this.$store.state.rsvpDetails.dispatchLogs.length },
    rsvpId () { return this.$route.params.id },
    driverId () { return this.$store.state.rsvpDetails.basicInfo.driverInfo.id },
    rsvpStatus () {
      let rsvpDetails = this.$store.state.rsvpDetails.basicInfo.tripInfo
      let trx = this.$store.state.rsvpDetails.transactionList
      let status = {
        class: rsvpDetails.status,
        label: rsvpDetails.status
      }
      if (status.label === 'ready' || rsvpDetails.bidStatus === 'ready') {
        status.class = 'ready'
        status.label = 'Ready to go'
      }
      if (status.label === 'onboard') { status.label = 'On Board' }
      if (rsvpDetails.bidStatus === 'dispatched') {
        status = {
          class: rsvpDetails.bidStatus,
          label: rsvpDetails.bidStatus
        }
      }
      if (rsvpDetails.bidStatus === 'requires_dispatch') {
        status = {
          class: 'requires-dispatch',
          label: 'Requires Dispatch'
        }
      }
      if (rsvpDetails.bidStatus === 'autodispatch') {
        status = {
          class: 'auto-dispatch',
          label: 'Auto Dispatch'
        }
      }
      if (rsvpDetails.status === 'complete') {
        status = {
          class: 'complete',
          label: 'completed'
        }
      }
      if (rsvpDetails.status === 'canceled') {
        status = {
          class: rsvpDetails.status,
          label: rsvpDetails.status
        }
        if (trx.length && trx[0].transactionType === 'CONVERT_CREDIT' && trx[0].notes !== 'RECLAIMED') {
          this.editEnabled = false
          status = {
            class: 'open-credit',
            label: 'Open Credit'
          }
        }
      }
      return status
    },
    rsvpDetails () { return this.$store.state.rsvpDetails.basicInfo },
    showBreakdownPayment () { return this.$store.state.rsvpDetails.showPaymentBreakdown },
    showFlightStatus () { return this.$store.state.rsvpDetails.showFlightStatus },
    driverPaymentBreakdown () {
      let tripInfo = this.$store.state.rsvpDetails.basicInfo.tripInfo
      let fare = tripInfo.driverPayment
      if (parseFloat(tripInfo.overridePayment) > 0) {
        fare = tripInfo.overridePayment
      }
      if (parseFloat(tripInfo.paymentBonus) > 0) {
        fare = tripInfo.basePay
      }
      return {
        fare: this.toFixed(fare),
        bonus: this.toFixed(tripInfo.driverBonus),
        tip: this.toFixed(tripInfo.tip),
        gasFee: this.toFixed(tripInfo.gasFee),
        pickupFee: this.toFixed(tripInfo.pickupFee),
        paymentBonus: this.toFixed(tripInfo.paymentBonus)
      }
    },
    isPackage () { return this.$store.state.rsvpDetails.basicInfo.tripInfo.packageId || false },
    showCancelButton () {
      let rsvpDetails = this.$store.state.rsvpDetails.basicInfo.tripInfo
      if (this.lyft.show) {
        if (['dispatched', 'onboard'].indexOf(rsvpDetails.bidStatus) > -1) return true
      }
      return rsvpDetails.bidStatus !== 'dispatched' &&
        this.rsvpStatus.class !== 'complete' && this.rsvpStatus.class !== 'canceled' &&
        this.rsvpStatus.class !== 'open-credit'
    },
    flightStatus () {
      return this.$store.state.rsvpDetails.flightStatus
    },
    showButtons () {
      return ['canceled', 'open-credit'].indexOf(this.rsvpStatus.class) === -1 ||
      (['canceled', 'open-credit'].indexOf(this.rsvpStatus.class) > -1 && this.activeTab.left === 2)
    },
    sendEmail () { return this.$store.state.rsvpDetails.sendEmail },
    sendNoShow () { return this.$store.state.rsvpDetails.sendNoShow },
    showReleaseModal () { return this.$store.state.rsvpDetails.showReleaseModal },
    rsvpAction () { return this.$store.state.rsvpDetails.rsvpAction },
    rsvpEditLocation () {
      let rsvpEdit = this.$store.state.rsvpDetails.edit.details
      return {
        id: rsvpEdit.tripInfo.id,
        pickup: rsvpEdit.tripInfo.pickup,
        dropoff: rsvpEdit.tripInfo.dropoff
      }
    },
    rsvpEditSubmit () {
      return this.$store.state.rsvpDetails.edit.showUpdateReturn
    },
    rsvpEditIsSaving () { return this.$store.state.rsvpDetails.edit.isSaving },
    isAirportPickup () { return this.$store.state.rsvpDetails.edit.details.tripInfo.isAirportPickup },
    isAirportDropoff () {
      let tripInfo = this.$store.state.rsvpDetails.basicInfo.tripInfo
      return tripInfo.isAirportDropoff && !tripInfo.isAirportPickup
    },
    suggestedTimeShow () { return this.$store.state.rsvpDetails.edit.suggestedTime.show },
    _airline () { return this.$store.state.rsvpDetails.edit.details.tripInfo.airline },
    _flightNo () { return this.$store.state.rsvpDetails.edit.details.tripInfo.flightNo },
    _pickupDate () { return this.$store.state.rsvpDetails.edit.details.tripInfo.pickupDate },
    _selectedService () { return this.$store.state.rsvpDetails.edit.selectedService },
    isNewRsvp () {
      if(this.$store.state.rsvpDetails.isAdd){
        this.showIconLog = false
      }
      return this.$store.state.rsvpDetails.isAdd },
    showSelectUser () { return this.$store.state.rsvpDetails.showSelectUser },
    showSelectCorporate () { return this.$store.state.rsvpDetails.showSelectCorporate },
    createRsvpLoading () { return this.$store.state.rsvpDetails.addLoading },
    showAsapModal () { return this.$store.state.rsvpDetails.asap.show },
    asapEnable () { return this.$store.state.rsvpDetails.asap.enable },
    asapLoading () { return this.$store.state.rsvpDetails.asap.loading },
    asapNoDriver () { return this.$store.state.rsvpDetails.asap.noDriver },
    asapDriverInfoLoading () { return this.$store.state.rsvpDetails.asap.driverInfoLoading },
    asapDriverInfo () { return this.$store.state.rsvpDetails.asap.driverInfo },
    createError () { return this.$store.state.rsvpDetails.submitError },
    showRTGButton () {
      return ['upcoming', 'Requires Dispatch', 'dispatched'].indexOf(this.rsvpStatus.label) > -1 && !this.isPackage &&
        this.rsvpDetails.tripInfo.pickup.geofenceType === 'airport'
    },
    editAccess () { return this.$store.state.session.user.access.hasOwnProperty('PageAdminRSVPEdit') },
    noteAccess () { return this.$store.state.session.user.access.hasOwnProperty('PageAdminNotes') },
    hasOngoingCall () { return this.$store.state.phone.ongoing },
    iconToggleRightPanel () { return this.showRightPanel ? 'fa fa-clipboard-list fa-2x' : 'fas fa-times fa-2x'},
    servicesLoading () { return this.$store.state.services.servicesLoading },
    dispatchStatus () {
      if (this.rsvpStatus.class === 'dispatched') {
        if (['ontheway', 'arrived'].indexOf(this.rsvpDetails.tripInfo.status) > -1) { return 'on-time' }

        let pickupTime = moment(this.rsvpDetails.tripInfo.pickupDate, 'MM/DD/YYYY ' + featureToggle.timeFormat(this, false))
        let pickupTime1 = parseInt(pickupTime.clone().subtract(this.$settings.get('DispatchLateCriticalMins'), 'minutes').format('X'))
        let pickupTime115 = parseInt(pickupTime.clone().subtract(this.$settings.get('DispatchLateWarningMins'), 'minutes').format('X'))
        let currentTime = parseInt(moment().format('X'))
        if (pickupTime1 <= currentTime) { return 'very-late' }
        if (pickupTime115 <= currentTime) { return 'late' }
        if (this.rsvpDetails.tripInfo.status === 'upcoming') { return 'accepted' }
      }
      return ''
    },
    emailRecipientModal () { return this.$store.state.rsvpDetails.emailRecipient },
    extraStops () { return this.$store.state.rsvpDetails.edit.details.tripInfo.extraStops },
    extraStops2 () { return this.$store.state.rsvpDetails.extraStops },
    totalExtraStops () { return 10 },
    _updateMap () { return this.$store.state.rsvpDetails.updateMap },
    isTerminal () { return this.$store.state.rsvpDetails.isTerminal },
    tripInfo () { return this.$store.state.rsvpDetails.basicInfo.tripInfo },
    optin () { return this.$store.state.rsvpDetails.optin },
    optinModal: {
      get () { return this.optin.showModal },
      set (x) { this.$store.commit('rsvpDetails/setOptinData', {showModal: x}) }
    },
    hasRSVPControl () { return this.$store.state.session.user.access.hasOwnProperty('PageAdminRsvpControl') },
    currency () { return this.$store.state.rsvpDetails.currency },
    useLocalCurrency () { return this.$store.state.rsvpDetails.useLocalCurrency },
    trackLink () {
      let brand = CONFIG.brands.find(x => x.id == this.tripInfo.brandId)
      return `${brand.url}?id=${this.rsvpId}&fname=${encodeURI(this.rsvpDetails.customerInfo.firstName)}&lname=${encodeURI(this.rsvpDetails.customerInfo.lastName)}#/search-track-direct`
    },
    lyft () { return this.$store.state.rsvpDetails.lyft },
    lyftStore () { return this.$store.state.lyft },
    allowOverridePayment () {
      return this.$store.state.session.user.access.hasOwnProperty('ForceDriverPaymentOverride') &&
        (
          CONFIG.lyftServiceIds.indexOf(this.tripInfo.serviceTypeId) > -1 || this.lyft.show ||
          (CONFIG.Env === 'production' && [272203, 263021].indexOf(this.rsvpDetails.driverInfo.id) > -1) ||
          (CONFIG.Env !== 'production' && [5116].indexOf(this.rsvpDetails.driverInfo.id) > -1)
        )
    },
    totalDriverPayment () {
      let tripInfo = this.$store.state.rsvpDetails.basicInfo.tripInfo
      let driverPayment = tripInfo.driverPayment
      if (parseFloat(tripInfo.overridePayment) > 0) {
        driverPayment = tripInfo.overridePayment
      }
      return this.toFixed(driverPayment + tripInfo.driverBonus +
        tripInfo.tip + tripInfo.pickupFee + tripInfo.gasFee)
    }
  },
  methods: {
    sendSMS () {
      if (this.$refs.sms.showSMSForm()) {
        this.$refs.sms.showSMSForm()
      }
    },
    showNotif () {
      if (this.$refs.notif.showNotifForm()) {
        this.$refs.notif.showNotifForm()
      }
    },
    init () {
      let self = this
      self.driverInMap = null
      self.infoWindows = []
      self.extraPins = []
      self.extraPinsPath = []
      self.completedPath = []
      self.cancelData = []
      self.editEnabled = false
      self.loading = true
      self.$store.commit('rsvpDetails/resetBasicInfo')

      if (self.$refs.HPickup.editMode(false)) {
        self.$refs.HPickup.editMode(false)
      }
      if (self.$refs.HDropoff.editMode(false)) {
        self.$refs.HDropoff.editMode(false)
      }

      ApiRsvp.getRsvpData(self, self.$route.params.id, function (res) {
        self.isAsapRsvp = res.isAsap
        if (res.error) {
          self.loading = false
          self.$router.push({name: 'MissingPage'})
          return
        }

        if (res.hasExtraStop) {
          self.getExtraStops(res)
          return
        }

        self.loading = false
        self.getAirportList()
        self.mtechData.id = ''
        if (res.isMTech) self.getMtechData()
        self.getLyftServices()
        // self.getLyftData()
        setTimeout(() => {
          self.showPinLocation(res)
        }, 600)
      })
    },
    getExtraStops (resData) {
      let self = this

      self.$sdk.get(`/admin/rsvp/${self.rsvpId}/extrastops`, {
        token: self.$store.state.session.sessionToken
      }, r => {
        self.loading = false
        let pins = resData
        if (!r.error) {
          if (r.list.length) {
            pins.extraStops = []
          }
          r.list.forEach(stop => {
            stop.id = stop.stopIndex
            pins.extraStops.push(stop)
          })
          self.$store.commit('rsvpDetails/setExtraStops', pins.extraStops)
        }
        self.getAirportList()
        setTimeout(() => {
          self.showPinLocation(pins)
        }, 600)
      })
    },
    toggleRightPanel () {
      this.showRightPanel = !this.showRightPanel
      if (!this.showRightPanel && this.lastRsvpId !== this.rsvpId) {
        this.lastRsvpId = this.rsvpId
        if (this.$refs.actionLogs.init()) {
          this.$refs.actionLogs.init()
        }
      }
    },
    switchTab (tab, index) {
      if (tab === 'left' && this.editEnabled && (index === 1 || index === 2)) { return }
      this.activeTab[tab] = index
    },
    closeBreakdown () {
      this.$store.commit('rsvpDetails/setShowPaymentBreakdown', false)
    },
    closeFlightStatus () {
      this.$store.commit('rsvpDetails/setShowFlightStatus', false)
    },
    getLatLng (location) {
      return {
        lat: parseFloat(location.lat),
        lng: parseFloat(location.lng)
      }
    },
    updateFlightStatus () {
      let self = this

      let rsvpDetails = self.$store.state.rsvpDetails
      let flightStatus = rsvpDetails.flightStatus.status
      let flightManual = rsvpDetails.flightManual
      if (flightStatus === '' || flightStatus === null || flightManual) {
        self.$store.commit('rsvpDetails/setFlightManual', true)
        self.$store.commit('rsvpDetails/setFlightStatus', {
          status: 'Scheduled',
          // departureAirport: res.departure.airportName + ' (' + res.departure.airportCode + ')',
          departureAirport: 'N/A',
          arrivalAirport: 'N/A',
          arrivalTime: 'N/A'
        })
        return
      }

      if (self.flightStatusLoading) { return }
      self.flightStatusLoading = true
      self.flightStatusError = false

      let tripInfo = rsvpDetails.basicInfo.tripInfo
      let pickupTime = moment(tripInfo.pickupDate, 'MM/DD/YYYY ' + featureToggle.timeFormat(self, false))
      ApiRsvp.getFlightStatus(self, {
        flightCode: tripInfo.airlineCode + tripInfo.flightNo,
        date: pickupTime.format('YYYY-MM-DD'),
        time: pickupTime.format('HH:mm:ss'),
        isDeparture: this.$store.state.rsvpDetails.basicInfo.tripInfo.isAirportPickup ? '0' : '1',
        airportCode: self.$store.state.rsvpDetails.basicInfo.tripInfo.airportCode
      }, function (res) {
        self.flightStatusLoading = false
        if (res.error) {
          self.flightStatusError = true
        }
      })
    },
    toFixed (value) {
      return parseFloat(value).toFixed(2)
    },
    AddNotes () {
      this.$store.commit('reservationNotes/show', {
        rsvpId: this.$route.params.id
      })
    },
    closeEmailResult () {
      this.$store.commit('rsvpDetails/setSendEmail', {
        show: false,
        message: ''
      })
      if (!this.noRelog) {
        window.location.reload()
      }
      this.noRelog = false
      return
    },
    closeNoShowResult () {
      let forceHide = this.$store.state.rsvpDetails.sendNoShow.forceHide
      if (forceHide) {
        location.reload()
        return
      }

      this.$store.commit('rsvpDetails/setSendNoShow', {
        showModal: false,
        loading: false,
        showMsg: false,
        message: '',
        forceHide: forceHide
      })
    },
    closeActionModal () {
      this.$store.commit('rsvpDetails/setRsvpAction', {
        show: false,
        message: ''
      })
    },
    closeEditSubmit () {
      if (this.rsvpEditSubmit.status === 'success') {
        window.location.reload()
        return
      }

      this.$store.commit('rsvpDetails/setShowUpdateReturn', {
        show: false,
        message: '',
        status: ''
      })
    },
    cancelRsvp () {
      if (this.rsvpDetails.tripInfo.d2dId) {
        this.$router.push(`/flight/${this.rsvpDetails.tripInfo.d2dId}`)
        return
      }
      this.$store.commit('reservationNotes/setNotesModalData', {
        isLyftService: this.rsvpDetails.tripInfo.serviceType.label.toLowerCase() === 'lyft'
      })
      this.$store.commit('reservationNotes/show', {
        rsvpId: this.$route.params.id,
        action: this.$settings.config.RideCreditOffer ? 'convertCredit' : 'cancel'
      })
    },
    markAsComplete () {
      let self = this
      if (!self.hasRSVPControl) return

      self.$store.commit('reservationNotes/show', {
        show: true,
        rsvpId: self.rsvpId,
        isPackage: false,
        forComplete: true,
        fromRsvpDetails: true
      })
    },
    releaseDriver () {
      let self = this
      self.releasingDriver = true
      self.releaseSuccess = false

      self.$sdk.delete('/admin/rsvp/' + self.rsvpId + '/driver', {
        token: self.$store.state.session.sessionToken,
        charge: self.release.charge
      }, r => {
        if (r.error) {
          self.releasingDriver = true
          self.releaseSuccess = false
          self.$store.commit('rsvpDetails/hideReleaseConfirmation')
          return
        }
        self.init()
        self.releaseSuccess = true
        setTimeout(() => {
          window.location.reload()
          // self.releasingDriver = false
          // self.$store.commit('rsvpDetails/hideReleaseConfirmation')
        }, 2000)
      })
    },
    toggleEdit () {
      let self = this
      self.editEnabled = !self.editEnabled
      self.showIconLog = !self.showIconLog

      if (self.$refs.HPickup.editMode(!self.editEnabled)) {
        self.$refs.HPickup.editMode(!self.editEnabled)
      }
      if (self.$refs.HDropoff.editMode(!self.editEnabled)) {
        self.$refs.HDropoff.editMode(!self.editEnabled)
      }

      if (self.editEnabled) {
        let basicInfo = JSON.parse(JSON.stringify(self.$store.state.rsvpDetails.basicInfo))
        if (basicInfo.tripInfo.pickup.title.indexOf('Apt/Gate') > -1) {
          basicInfo.tripInfo.aptGate = basicInfo.tripInfo.pickup.title.split(' Apt/Gate: ')[1]
          basicInfo.tripInfo.pickup.title = basicInfo.tripInfo.pickup.title.split(' Apt/Gate: ')[0]
        }

        if (self.$store.state.rsvpDetails.extraStops) {
          if (self.$store.state.rsvpDetails.extraStops.length) {
            basicInfo.tripInfo.extraStops = []
            self.$store.state.rsvpDetails.extraStops.forEach(stop => {
              basicInfo.tripInfo.extraStops.push(stop)
            })
          }
        }

        self.$store.commit('rsvpDetails/setEditData', basicInfo)
        let tripInfo = this.$store.state.rsvpDetails.basicInfo.tripInfo
        if (tripInfo.isCharter) {
          self.$store.commit('rsvpDetails/setCharterData', {
            enabled: true,
            pickup: tripInfo.pickup,
            startDate: tripInfo.pickupDate,
            endDate: moment(tripInfo.pickupDate, 'MM/DD/YYYY hh:mmA').add(tripInfo.eta, 'seconds').format('MM/DD/YYYY hh:mmA')
          })
        }

        self.$store.commit('rsvpDetails/setTimezoneLoading', true)
        ApiLocation.getTimezone(self, {
          lat: tripInfo.pickup.lat,
          lng: tripInfo.pickup.lng
        }, function (res) {
          // TODO: on error
          self.$store.commit('rsvpDetails/setTimezoneLoading', false)
          self.$store.commit('rsvpDetails/setTimezone', res)
        })

        if (self.$store.state.brands.list.length === 0) {
          self.$store.commit('brands/setLoading', true)
          // self.$store.commit('rsvpDetails/setBrandsLoading', true)
          self.$sdk.get('/brand', {}, res => {
            self.$store.commit('brands/setLoading', false)
            // self.$store.commit('rsvpDetails/setBrandsLoading', false)
            let brands = []
            res.forEach(function (data) {
              brands.push({
                id: data.id,
                name: data.name
              })
            })
            self.$store.commit('brands/setList', brands)
            // self.$store.commit('rsvpDetails/setBrandsList', brands)
          })
        }

        self.$store.commit('rsvpDetails/setEditCurrency', {
          code: self.currency.currency,
          symbol: self.currency.symbol,
          value: self.currency.currencyRate
        })

        self.switchTab('left', 0)
        if (self.$refs.edit.init()) { self.$refs.edit.init() }

        setTimeout(function () {
          let mapData = {
            ID: tripInfo.id,
            pickupLocation: tripInfo.pickup,
            dropoffLocation: tripInfo.dropoff
          }
          self.showPinLocation(mapData)
          self.setCenter()
        }, 650)
      } else {
        setTimeout(function () {
          self.setCenter()
        }, 670)
      }
    },
    editRsvpSave () {
      if (this.isNewRsvp) {
        if (this.$refs.edit.createRsvp()) {
          this.$refs.edit.createRsvp()
        }
        return
      }

      if (this.$refs.edit.save()) {
        this.$refs.edit.save()
      }
    },
    getAirportList () {
      let self = this
      if (self.$store.state.airports.list.length > 0) { return }

      self.$store.commit('airports/setLoading', true)
      self.$sdk.get('/airports', {}, res => {
        // TODO: if getting airports fail do something ...

        self.$store.commit('airports/setLoading', false)
        let list = []
        res.list.forEach(function (data) {
          let add1 = data.addressLine2 === null ? data.addressLine1 : data.addressLine2
          let add2 = data.addressLine2 === null ? '' : data.addressLine1
          let title = add2 + ' ' + add1 + ', ' + data.city + ', ' + data.state + ' ' + data.zipCode
          if (data.enabled) {
            list.push({
              geofenceId: data.id,
              geofenceType: 'airport',
              address1: add1,
              address2: add2,
              city: data.city,
              lat: data.lat,
              lng: data.lng,
              state: data.state,
              title: data.name || title,
              zip: data.zipCode,
              description: data.description,
              airportCode: data.airportCode,
              locationId: data.locationId
            })
          }
        })
        self.$store.commit('airports/setList', list)
      })
    },
    noShowMessage () {
      let basicInfo = this.$store.state.rsvpDetails.basicInfo
      // let consumer = basicInfo.customerInfo
      // let provider = basicInfo.driverInfo
      let msg = this.$t('rsvpDetails.noShow.bodyConsumer')
      if (basicInfo.driverInfo.firstName) {
        msg = msg + ' ' + this.$t('rsvpDetails.noShow.bodyProvider', {
          fee: basicInfo.tripInfo.packageId ? this.$settings.config.ChainNoShowFee : this.$settings.config.ExclusiveNoShowFee
        })
      }
      msg = msg + ' ' + this.$t('rsvpDetails.noShow.bodyConfirm')

      return msg
    },
    applyNoShow () {
      let self = this
      self.$store.commit('rsvpDetails/setSendNoShow', {
        showModal: true,
        loading: true,
        show: false,
        message: '',
        forceHide: false
      })
      ApiRsvp.sendNoShow(self, self.$store.state.rsvpDetails.rsvpId, function (res) {
        self.$store.commit('rsvpDetails/setSendNoShow', {
          showModal: true,
          loading: false,
          show: true,
          message: self.$t('rsvpDetails.noShowSent'),
          forceHide: true
        })

        if (res.error) {
          self.$store.commit('rsvpDetails/setSendNoShow', {
            showModal: true,
            loading: false,
            show: true,
            message: res.error.message,
            forceHide: false
          })
        }
      })
    },
    closeSuggestedTime () { this.$store.commit('rsvpDetails/setSuggestedTimeShow', false) },
    checkSuggestedTime () {
      if (!this.editEnabled) { return }

      let edit = this.$store.state.rsvpDetails.edit
      let rsvp = edit.details.tripInfo

      if (rsvp.airline && rsvp.flightNo && edit.lastFlightNo && rsvp.flightNo === edit.lastFlightNo &&
        rsvp.pickupDate && this.suggestedTime() &&
        rsvp.pickupDate !== this.suggestedTime() && this._selectedService
      ) {
        this.$store.commit('rsvpDetails/setSuggestedTimeShow', true)
      }
    },
    applySuggestedTime () {
      this.$store.commit('rsvpDetails/setPickupDate', this.suggestedTime())
      if (this.$refs.edit.updatePickupDate()) { this.$refs.edit.updatePickupDate() }
      this.closeSuggestedTime()
    },
    suggestedTime () {
      let edit = this.$store.state.rsvpDetails.edit
      let rsvp = edit.details.tripInfo
      if (!edit.suggestedTime.time) { return '' }

      let date = moment(edit.suggestedTime.time, 'MM/DD/YYYY ' + featureToggle.timeFormat(this, false))
      if (rsvp.isAirportPickup) {
        let delay = edit.suggestedTime.isDomestic ? 'ArrivalDomesticDelay' : 'ArrivalInternationalDelay'
        date.add(this.$settings.get(delay), 'minutes')
      } else if (rsvp.isAirportDropoff) {
        let delay = edit.suggestedTime.isDomestic ? 'DepartureDomesticBuffer' : 'DepartureInternationalBuffer'
        let eta = Math.ceil(rsvp.eta / 60)
        let btt = Math.ceil(eta * 1.15)
        if (this._selectedService === 'shared') {
          btt = Math.ceil(eta * (1 + (this.$settings.get('OfferLimitThreshold') / 100)))
          btt = (btt - (btt % 5)) + 5
        }
        let timeDelay = Math.ceil(parseFloat(this.$settings.get(delay)))
        date.subtract(timeDelay + btt, 'minutes')
        date.subtract(parseInt(date.format('mm')) % 5, 'minutes')
      }

      return !date.isBefore(moment().add(this.$settings.get('AdminTimeBuffer'), 'minutes')) ? date.format('MM/DD/YYYY ' + featureToggle.timeFormat(this, false)) : ''
      // return this.$store.state.rsvpDetails.edit.suggestedTime.time
    },
    initNewRsvp () {
      let self = this

      if (self.$refs.HPickup.editMode(true)) {
        self.$refs.HPickup.editMode(true)
      }
      if (self.$refs.HDropoff.editMode(true)) {
        self.$refs.HDropoff.editMode(true)
      }

      self.editEnabled = true
      if (self.$store.state.brands.list.length === 0) {
        self.$store.commit('brands/setLoading', true)

        self.$sdk.get('/brand', {}, res => {
          self.$store.commit('brands/setLoading', false)
          let brands = []
          res.forEach(function (data) {
            brands.push({
              id: data.id,
              name: data.name
            })
          })
          self.$store.commit('brands/setList', brands)
        })
      }

      self.getAirportList()
      self.switchTab('left', 0)
      self.getCurrencyList()
    },
    closeShowSelectUser () { this.$store.commit('rsvpDetails/setShowSelectUser', false) },
    closeShowSelectCorporate () { this.$store.commit('rsvpDetails/setShowSelectCorporate', false) },
    searchUser () {
      let self = this
      self.users.pageNum = 1
      self.users.list = []
      self.getUser()
    },
    getUser () {
      let self = this
      if (self.users.loading) { return }

      self.users.loading = true
      self.$sdk.get('/consumer', {
        token: self.$store.state.session.sessionToken,
        search: self.users.input,
        pageNum: self.users.pageNum,
        pageSize: 5
      }, res => {
        self.users.loading = false
        if (!res.error) {
          if (res.list.length) {
            let users = []
            res.list.forEach(function (user) {
              users.push({
                id: user.ID,
                firstName: user.firstName,
                lastName: user.lastName,
                email: user.email,
                mobile: user.phone,
                countryCode: user.countryCode,
                isD2d: user.d2d,
                nationalNumber: user.nationalNumber
              })
            })
            self.users.list = users
          }
        }
      })
    },
    selectUser (index) {
      let users = this.users.list
      this.$store.commit('rsvpDetails/setCustomerInfo', {
        id: users[index].id,
        firstName: users[index].firstName,
        lastName: users[index].lastName,
        email: users[index].email,
        mobile: users[index].mobile,
        countryCode: users[index].countryCode,
        nationalNumber: users[index].nationalNumber
      })

      this.$store.commit('rsvpDetails/setIsCorporate', false)
      this.getUserCards(this.users.list[index].id)
      this.closeShowSelectUser()

      if (this.$refs.edit.resetPaymentMethod()) {
        this.$refs.edit.resetPaymentMethod()
      }
    },
    getUserCards (id) {
      let self = this
      if (self.$store.state.rsvpDetails.userCard.loading) { return }

      self.$store.commit('rsvpDetails/setUserCardLoading', true)
      ApiRsvpAdd.getCards(self, id, function (res) {
        self.$store.commit('rsvpDetails/setUserCardLoading', false)
      })
    },
    searchCorporate () {
      this.corporate.pageNum = 1
      this.corporate.list = []
      this.getCorporate()
    },
    getCorporate () {
      let self = this
      if (self.corporate.loading) { return }

      self.corporate.loading = true
      self.$sdk.get('/admin/corporateprofile', {
        token: self.$store.state.session.sessionToken,
        search: self.corporate.input,
        pageNum: self.corporate.pageNum,
        pageSize: self.corporate.pageSize
      }, res => {
        self.corporate.loading = false
        if (!res.error) {
          if (res.list.length) {
            let users = []
            res.list.forEach(function (user) {
              let displayMobile = user.contactPhone
              if (displayMobile.indexOf('+') === -1) displayMobile = `+${displayMobile}`
              users.push({
                id: user.id,
                consId: user.customer.ID,
                firstName: user.name,
                lastName: '',
                email: user.contactEmail,
                mobile: user.contactPhone,
                countryCode: '',
                displayMobile: displayMobile,
                active: user.active
              })
            })
            self.corporate.list = users
          }
        }
      })
    },
    selectCorporate (index) {
      let mobile = this.corporate.list[index].mobile
      if (mobile.indexOf('+') > -1) mobile = mobile.substring(1)
      let countryCode = this.corporate.list[index].countryCode
      if (countryCode.indexOf('+') > -1) countryCode = countryCode.substring(1)
      if (!this.corporate.list[index].active) return
      this.$store.commit('rsvpDetails/setCustomerInfo', {
        id: this.corporate.list[index].id,
        firstName: this.corporate.list[index].firstName,
        lastName: this.corporate.list[index].lastName,
        email: this.corporate.list[index].email,
        mobile: mobile,
        countryCode: countryCode,
        consId: this.corporate.list[index].consId,
        active: this.corporate.list[index].active
      })

      this.$store.commit('rsvpDetails/setIsCorporate', true)
      this.getUserCards(this.corporate.list[index].consId)
      this.closeShowSelectCorporate()

      if (this.$refs.edit.resetPaymentMethod()) {
        this.$refs.edit.resetPaymentMethod()
      }
    },
    cancelAsap () {
      let self = this
      self.$sdk.delete('/admin/rsvp/asap', {
        token: self.$store.state.session.sessionToken,
        brandId: self.asapBrandId,
        bidID: self.asapBidId,
        serviceType: self.asapService
      }, r => {
        self.$store.commit('rsvpDetails/asapReset')
      })
    },
    asapChangeService () { this.$store.commit('rsvpDetails/asapReset') },
    asapTryAgain () {
      let self = this
      if (self.$refs.edit.getDriver()) {
        self.$store.commit('rsvpDetails/setAsapLoading', true)
        self.$refs.edit.getDriver()
      }
    },
    closeDoneAsap () { window.location.reload() },
    closeCreateError () { this.$store.commit('rsvpDetails/setSubmitError', {show: false, message: ''}) },
    showRTG (id) {
      this.$store.commit('dispatch/setReadyToGoID', id)
      this.$store.commit('dispatch/setReadyToGoShow', true)
    },
    computeHeading (orig, dest) {
      let y = Math.sin(dest.lng - orig.lng) * Math.cos(dest.lat)
      let x = Math.cos(orig.lat) * Math.sin(dest.lat) -
        Math.sin(orig.lat) * Math.cos(dest.lat) * Math.cos(dest.lng - orig.lng)
      let brng = Math.atan2(y, x) * 180 / Math.PI
      return Math.round(360 - ((brng + 360) % 360))
    },
    extraPinIcon (type) { return mapPins[type] },
    call () {
      let self = this
      let user = self.rsvpDetails.driverInfo
      self.$plugins.phone.startCall(self, {
        phone: user.mobile,
        name: user.firstName + ' ' + user.lastName
      })
    },
    initMap () {
      let self = this
      let mapContainer = document.getElementById('mapHere')
      self.hereMaps.platform = new window.H.service.Platform({
        apikey: CONFIG.hereApi.key
      })

      let defaultLayers = self.hereMaps.platform.createDefaultLayers()
      self.hereMaps.map = new window.H.Map(mapContainer,
        defaultLayers.vector.normal.map, {
          center: self.center,
          zoom: 13,
          pixelRatio: window.devicePixelRatio || 1
        }
      )

      /* eslint-disable no-unused-vars */
      let behavior = new window.H.mapevents.Behavior(new window.H.mapevents.MapEvents(self.hereMaps.map))
      /* eslint-enable no-unused-vars */
      self.hereMaps.ui = window.H.ui.UI.createDefault(self.hereMaps.map, defaultLayers)
      window.addEventListener('resize', () => self.hereMaps.map.getViewPort().resize())
    },
    showPinLocation (data) {
      let self = this
      self.mapLoader.show = true
      self.mapLoader.label = 'LOADING RSVP...'

      if (typeof data.dropoffLocation === 'undefined' ||
        typeof data.pickupLocation === 'undefined') {
        self.mapLoader.show = false
        return
      }

      // Pickup/Dropoff icon
      let marker = '<svg height="25" width="25" style="overflow: unset" viewBox="0 0 50 50">' +
        '<path d="{D}" fill="{FILL}"stroke="{STROKE}"' +
        'stroke-width="{STROKE_WIDTH}" /></svg>'

      // Add Pickup Pin
      if (data.pickupLocation) {
        for (let object of self.hereMaps.map.getObjects()) {
          if (object.id === 'pickup-pin') { self.hereMaps.map.removeObject(object) }
        }
        self.hereMaps.ui.getBubbles().forEach(bub => {
          if (bub.id === 'pickup-info') { self.hereMaps.ui.removeBubble(bub) }
        })
        let pickupMarker = marker.replace('{D}', mapPins.pickup.path)
          .replace('{FILL}', mapPins.pickup.fillColor)
          .replace('{STROKE}', mapPins.pickup.strokeColor)
          .replace('{STROKE_WIDTH}', mapPins.pickup.strokeWeight)
        let pickupIcon = new window.H.map.DomIcon(pickupMarker)
        let pickupCoords = {lat: data.pickupLocation.lat, lng: data.pickupLocation.lng}
        let pickupPin = new window.H.map.DomMarker(
          pickupCoords,
          {icon: pickupIcon}
        )
        pickupPin.id = 'pickup-pin'

        self.infoWindows.push({
          lat: data.pickupLocation.lat,
          lng: data.pickupLocation.lng,
          type: 'pickup',
          opened: false
        })

        self.hereMaps.ui.getBubbles().forEach(bub => {
          if (bub.id === 'pickup-info') { self.hereMaps.ui.removeBubble(bub) }
        })
        if (!self.editEnabled) {
          let infoWindow = document.getElementById('HPickup')
          let pickupBubble = new window.H.ui.InfoBubble(pickupCoords, {content: infoWindow})
          pickupBubble.id = 'pickup-info'
          self.hereMaps.ui.addBubble(pickupBubble)
          self.hereMaps.ui.getBubbles().forEach(bub => {
            if (bub.id === 'pickup-info') { bub.addClass('pickup-info') }
          })
          pickupPin.addEventListener('tap', function (evt) {
            pickupBubble.open()
          }, false)
        }
        self.hereMaps.map.addObject(pickupPin)
      }

      // Add ExtraStop Pin
      for (let object of self.hereMaps.map.getObjects()) {
        if (object.id === 'extraStop-pin') { self.hereMaps.map.removeObject(object) }
      }
      self.hereMaps.ui.getBubbles().forEach(bub => {
        if (bub.id === 'extraStop-info') { self.hereMaps.ui.removeBubble(bub) }
      })
      if (data.extraStops) {
        data.extraStops.forEach((stop, index) => {
          let extraStopMarker = marker.replace('{D}', mapPins.stop.path)
            .replace('{FILL}', mapPins.stop.fillColor)
            .replace('{STROKE}', mapPins.stop.strokeColor)
            .replace('{STROKE_WIDTH}', mapPins.stop.strokeWeight)
          let extraStopIcon = new window.H.map.DomIcon(extraStopMarker)
          let extraStopCoords = {lat: stop.lat, lng: stop.lng}
          let extraStopPin = new window.H.map.DomMarker(
            extraStopCoords,
            {icon: extraStopIcon}
          )
          extraStopPin.id = 'extraStop-pin'
  
          self.infoWindows.push({
            lat: stop.lat,
            lng: stop.lng,
            type: 'extraStop',
            opened: false
          })
  
          self.hereMaps.ui.getBubbles().forEach(bub => {
            if (bub.id === 'extraStop-info') { self.hereMaps.ui.removeBubble(bub) }
          })
          if (!self.editEnabled) {
            let infoWindow = document.getElementById(`HExtraStop${index}`)
            let extraStopBubble = new window.H.ui.InfoBubble(extraStopCoords, {content: infoWindow})
            extraStopBubble.id = 'extraStop-info'
            self.hereMaps.ui.addBubble(extraStopBubble)
            self.hereMaps.ui.getBubbles().forEach(bub => {
              if (bub.id === 'extraStop-info') { bub.addClass('extraStop-info') }
            })
            extraStopPin.addEventListener('tap', function (evt) {
              extraStopBubble.open()
            }, false)
          }
          self.hereMaps.map.addObject(extraStopPin)
        })
      }

      // Add Dropoff Pin
      if (data.dropoffLocation && !self.tripInfo.isCharter) {
        for (let object of self.hereMaps.map.getObjects()) {
          if (object.id === 'dropoff-pin') { self.hereMaps.map.removeObject(object) }
        }
        self.hereMaps.ui.getBubbles().forEach(bub => {
          if (bub.id === 'dropoff-info') { self.hereMaps.ui.removeBubble(bub) }
        })
        let dropoffMarker = marker.replace('{D}', mapPins.dropoff.path)
          .replace('{FILL}', mapPins.dropoff.fillColor)
          .replace('{STROKE}', mapPins.dropoff.strokeColor)
          .replace('{STROKE_WIDTH}', mapPins.dropoff.strokeWeight)
        let dropoffIcon = new window.H.map.DomIcon(dropoffMarker)
        let dropoffCoords = {lat: data.dropoffLocation.lat, lng: data.dropoffLocation.lng}
        let dropoffPin = new window.H.map.DomMarker(
          dropoffCoords,
          {icon: dropoffIcon}
        )
        dropoffPin.id = 'dropoff-pin'

        self.hereMaps.ui.getBubbles().forEach(bub => {
          if (bub.id === 'dropoff-info') {
            self.hereMaps.ui.removeBubble(bub)
          }
        })
        if (!self.editEnabled) {
          let infoWindow2 = document.getElementById('HDropoff')
          let dropoffBubble = new window.H.ui.InfoBubble(dropoffCoords, {content: infoWindow2})
          dropoffBubble.id = 'dropoff-info'
          self.hereMaps.ui.addBubble(dropoffBubble)
          self.hereMaps.ui.getBubbles().forEach(bub => {
            if (bub.id === 'dropoff-info') { bub.addClass('dropoff-info') }
          })
          dropoffPin.addEventListener('tap', function (evt) {
            dropoffBubble.open()
          }, false)
        }
        self.hereMaps.map.addObject(dropoffPin)
        self.infoWindows.push({
          lat: data.dropoffLocation.lat,
          lng: data.dropoffLocation.lng,
          type: 'dropoff',
          opened: false
        })
        self.infoWindows.push({
          lat: 0,
          lng: 0,
          opened: false
        })
      }

      if (data.pickupLocation && data.dropoffLocation) {
        let extra = {type:'rsvpRoute'}
        if (data.extraStops) {
          extra.stops = []
          data.extraStops.forEach(stop => {
            extra.stops.push(stop)
          })
        }
        self.calculateRoute(data.pickupLocation, data.dropoffLocation, extra)
      }
    },
    addMarker (data, type) {
      let self = this
      if (type === 'car') {
        if (['canceled', 'complete'].indexOf(self.rsvpDetails.tripInfo.status) > -1) {
          // remove current
          return
        }
        let marker = '<div class="here-pin car"><img src="{CAR_URL}" style="transform: rotate({DEGREE}deg)"/></div>'
        let carMarker = marker.replace('{CAR_URL}', 'https://mobile-consumer-app.s3-us-west-2.amazonaws.com/maps/car.png')
          .replace('{DEGREE}', data.heading)
        let pickupIcon = new window.H.map.DomIcon(carMarker)
        let coords = {lat: data.lat, lng: data.lng}
        let pin = new window.H.map.DomMarker(
          coords,
          {icon: pickupIcon}
        )

        // Added delay bec. i keep getting old data of infoWindows
        setTimeout(function () {
          let infoIndex = self.infoWindows.findIndex(x => x.type === 'vehicle')
          let eta = ''
          if (self.infoWindows[infoIndex].eta) {
            eta = ', ' + self.infoWindows[infoIndex].eta + ' minutes away'
          }
          let data = {
            driverInfo: self.rsvpDetails.driverInfo,
            driverPhoto: self.rsvpDetails.driverInfo.photo,
            driverUrl: '/#/provider/' + self.rsvpDetails.driverInfo.id,
            driverName: self.rsvpDetails.driverInfo.firstName + ' ' + self.rsvpDetails.driverInfo.lastName,
            distance: self.infoWindows[infoIndex].distance + ' miles',
            eta: eta,
            vehiclePhoto: self.rsvpDetails.driverInfo.vehiclePhoto,
            model: self.rsvpDetails.driverInfo.make + ' ' + self.rsvpDetails.driverInfo.model,
            license: self.rsvpDetails.driverInfo.licensePlate,
            call: self.$t('dispatch.driverCall', { driverName: self.rsvpDetails.driverInfo.firstName })
          }
          if (self.$refs.HCar.update(data)) {
            self.$refs.HCar.update(data)
          }
          let infoWindow = document.getElementById('HCar')
          let carBubble = new window.H.ui.InfoBubble(coords, {content: infoWindow})
          carBubble.id = 'car-info'
          self.hereMaps.ui.addBubble(carBubble)
          pin.addEventListener('tap', function (evt) {
            carBubble.open()
          }, false)
          self.hereMaps.map.addObject(pin)
          self.hereMaps.ui.getBubbles().forEach(bub => {
            if (bub.id === 'car-info') {
              bub.addClass('car-info')
            }
          })
        }, 1500)
      }
      if (type === 'extra') {
        let marker = '<svg height="25" width="25" style="overflow: unset" viewBox="0 0 50 50">' +
          '<path d="{D}" fill="{FILL}"stroke="{STROKE}"' +
          'stroke-width="{STROKE_WIDTH}" /></svg>'
        let carMarker = marker.replace('{D}', mapPins[data.status].path)
          .replace('{FILL}', mapPins[data.status].fillColor)
          .replace('{STROKE}', mapPins[data.status].strokeColor)
          .replace('{STROKE_WIDTH}', mapPins[data.status].strokeWeight)
        let carIcon = new window.H.map.DomIcon(carMarker)
        let coords = {lat: data.lat, lng: data.lng}
        let extraPin = new window.H.map.DomMarker(
          coords,
          {icon: carIcon}
        )
        extraPin.id = data.status
        let infoWindow = `<div class="here-info-window extra">
          <div><label>{LABEL}: </label><span>{VALUE}</span></div>
          {ONBOARD}
        </div>`
        let label = ''
        if (data.status === 'ontheway') { label = 'On The Way'}
        if (data.status === 'arrived') { label = 'Arrived'}
        if (data.status === 'completed') { label = 'Completed'}
        let onboard = ''
        if (self.rsvpDetails.tripInfo.onboard && data.status === 'arrived') {
          onboard = '<div><label>On Board: </label><span>' + self.rsvpDetails.tripInfo.onboard + '</span></div>'
        }
        infoWindow = infoWindow.replace('{LABEL}', label)
          .replace('{VALUE}', data.created)
          .replace('{ONBOARD}', onboard)
        let extraBubble = new window.H.ui.InfoBubble(coords, {
          content: infoWindow
        })
        extraBubble.id = 'extra-info'
        self.hereMaps.ui.addBubble(extraBubble)
        self.hereMaps.ui.getBubbles().forEach(bub => {
          if (bub.id === 'extra-info') { bub.addClass('extra-info') }
        })
        extraPin.addEventListener('tap', function (evt) {
          extraBubble.open()
        }, false);
        if (!data.opened) { extraBubble.close() }
        self.hereMaps.map.addObject(extraPin)
      }
    },
    calculateRoute (origin, destination, extraData) {
      let self = this

      if (extraData.type === 'rsvpRoute') {
        for (let object of self.hereMaps.map.getObjects()) {
          if (object.id === 'rsvpRoute') {
            self.hereMaps.map.removeObject(object)
          }
        }
      }

      if (extraData.stops && extraData.stops.length) {
        let url = 'https://router.hereapi.com/v8/routes?apiKey={API_KEY}&origin={ORIGIN}&destination={DESTINATION}&transportMode=car&return=polyline,summary'
        url = url.replace('{ORIGIN}', `${origin.lat},${origin.lng}`)
          .replace('{DESTINATION}', `${destination.lat},${destination.lng}`)
          .replace('{API_KEY}', CONFIG.hereApi.key)
        extraData.stops.forEach(stop => {
          url += `&via=${stop.lat},${stop.lng}`
        })
        request.get({
          url: url,
          json: true
        }, function (err, res, body) {
          if (err) {
            self.onCalculateError(err)
            return
          }
          if (!body.routes.length) return
          if (body.routes.length) {
            body.routes[0].sections.forEach(route => {
              self.addRouteShapeToMap(route, extraData)
            })
          }
        })
        return
      }
      let router = self.hereMaps.platform.getRoutingService(null, 8)
      let routeRequestParams = {
        routingMode: 'fast',
        transportMode: 'car',
        origin: `${origin.lat},${origin.lng}`,
        destination: `${destination.lat},${destination.lng}`,
        return: 'polyline,turnByTurnActions,actions,instructions,travelSummary'
      }
      router.calculateRoute(
        routeRequestParams,
        self.onCalculateSuccess.bind(null, extraData),
        self.onCalculateError
      )
    },
    onCalculateSuccess (extraData, result) {
      if (result.routes.length) {
        var route = result.routes[0].sections[0]
        if (extraData.type === 'driverRoute') {
          if (this.$refs.HCar) {
            this.$refs.HCar.updateField({
              field: 'distance',
              value: `${Math.ceil(route.travelSummary.length / 1609)} miles`
            })
          }
        }
        this.addRouteShapeToMap(route, extraData)
      }
    },
    onCalculateError (data) {
      console.error('ROUTING ERROR--', data)
    },
    addRouteShapeToMap (route, extraData) {
      let self = this

      let strokeColor = '#333333'
      if (extraData.type === 'driverRoute') { strokeColor = '#0D79F2' }
      if (extraData.type === 'extraRoute') { strokeColor = '#e57511' }
      if (extraData.type === 'completedRoute') { strokeColor = '#26D97A' }

      let linestring = window.H.geo.LineString.fromFlexiblePolyline(route.polyline);
      let polyline = new window.H.map.Polyline(linestring, {
        style: {
          lineWidth: 3,
          strokeColor: strokeColor
        }
      });
      polyline.id = extraData.type

      this.hereMaps.map.addObject(polyline)
      this.hereMaps.map.getViewModel().setLookAtData({
        bounds: polyline.getBoundingBox()
      })

      this.setCenter()
    },
    setCenter () {
      let self = this
      let group = new window.H.map.Group()

      // remove duplicate pin bound
      for (let object of self.hereMaps.map.getObjects()) {
        if (object.id === 'driverRoute' || object.id === 'groupBound' ||
          (object.icon && object.icon.c && object.icon.c.id === 'H_car_icon')
        ) {
          self.hereMaps.map.removeObject(object)
        }
      }

      // Create object with radius for better bounds
      let groupObject = []
      let editRsvpDetails = this.$store.state.rsvpDetails.edit.details.tripInfo
      if (self.editEnabled && editRsvpDetails.pickup.lat) {
        groupObject.push(new window.H.map.Circle(
          new window.H.geo.Point(editRsvpDetails.pickup.lat, editRsvpDetails.pickup.lng),
          3500,
          {
            style: {
              fillColor: 'rgba(0, 0, 0, 0)',
              strokeColor: 'rgba(0, 0, 0, 0)'
            }
          }
        ))
      } else if (self.rsvpDetails.tripInfo.pickup.lat) {
        groupObject.push(new window.H.map.Circle(
          new window.H.geo.Point(self.rsvpDetails.tripInfo.pickup.lat, self.rsvpDetails.tripInfo.pickup.lng),
          3500,
          {
            style: {
              fillColor: 'rgba(0, 0, 0, 0)',
              strokeColor: 'rgba(0, 0, 0, 0)'
            }
          }
        ))
      }
      if (self.editEnabled) {
        if (editRsvpDetails.extraStops) {
          if (editRsvpDetails.extraStops.length) {
            editRsvpDetails.extraStops.forEach(stop => {
              if (stop.lat && stop.lng) {
                groupObject.push(new window.H.map.Circle(
                  new window.H.geo.Point(stop.lat, stop.lng),
                  3500,
                  {
                    style: {
                      fillColor: 'rgba(0, 0, 0, 0)',
                      strokeColor: 'rgba(0, 0, 0, 0)'
                    }
                  }
                ))
              }
            })
          }
        }
      } else {
        if (self.$store.state.rsvpDetails.extraStops && self.$store.state.rsvpDetails.extraStops.length) {
          self.$store.state.rsvpDetails.extraStops.forEach(stop => {
            if (stop.lat && stop.lng) {
              groupObject.push(new window.H.map.Circle(
                new window.H.geo.Point(stop.lat, stop.lng),
                3500,
                {
                  style: {
                    fillColor: 'rgba(0, 0, 0, 0)',
                    strokeColor: 'rgba(0, 0, 0, 0)'
                  }
                }
              ))
            }
          })
        }
      }
      if (self.editEnabled && editRsvpDetails.dropoff.lat) {
        groupObject.push(new window.H.map.Circle(
          new window.H.geo.Point(editRsvpDetails.dropoff.lat, editRsvpDetails.dropoff.lng),
          3500,
          {
            style: {
              fillColor: 'rgba(0, 0, 0, 0)',
              strokeColor: 'rgba(0, 0, 0, 0)'
            }
          }
        ))
      } else if (self.rsvpDetails.tripInfo.dropoff.lat) {
        groupObject.push(new window.H.map.Circle(
          new window.H.geo.Point(self.rsvpDetails.tripInfo.dropoff.lat, self.rsvpDetails.tripInfo.dropoff.lng),
          3500,
          {
            style: {
              fillColor: 'rgba(0, 0, 0, 0)',
              strokeColor: 'rgba(0, 0, 0, 0)'
            }
          }
        ))
      }

      // Add to group for bounds correction
      if (groupObject.length) {
        group.addObjects(groupObject)
        group.id = 'groupBound'
        self.hereMaps.map.addObject(group)

        self.hereMaps.map.getViewModel().setLookAtData({
          bounds: group.getBoundingBox()
        })
        self.mapLoader.show = false
      }
    },
    saveNotes (id) {
      if (this.$refs.edit.saveNotes(id)) {
        this.$refs.edit.saveNotes(id)
      }
    },
    dispatchStatusChecker () {
      if (this.rsvpStatus.class === 'dispatched') {
        if (['ontheway', 'arrived'].indexOf(this.rsvpDetails.tripInfo.status) > -1) {
          this.dispatchStatusX = 'on-time'
          return
        }
        
        let pickupTime = moment(this.rsvpDetails.tripInfo.pickupDate, 'MM/DD/YYYY ' + featureToggle.timeFormat(this, false))
        let pickupTime1 = parseInt(pickupTime.clone().subtract(this.$settings.get('DispatchLateCriticalMins'), 'minutes').format('X'))
        let pickupTime115 = parseInt(pickupTime.clone().subtract(this.$settings.get('DispatchLateWarningMins'), 'minutes').format('X'))
        let currentTime = parseInt(moment().format('X'))
        if (pickupTime1 <= currentTime) {
          this.dispatchStatusX = 'very-late'
          return
        }
        if (pickupTime115 <= currentTime) {
          this.dispatchStatusX = 'late'
          return
        }
        if (this.rsvpDetails.tripInfo.status === 'upcoming') {
          this.dispatchStatusX = 'accepted'
          return
        }
      }
    },
    runTimer () {
      let self = this
      let rsvp = self.rsvpDetails.tripInfo
      let pickupTime = moment(rsvp.pickupDate, 'MM/DD/YYYY ' + featureToggle.timeFormat(this, false))
      let currentTime = parseInt(moment().format('X'))

      if (self.rsvpStatus.class === 'dispatched') {
        let pickupTime1 = parseInt(pickupTime.clone().subtract(this.$settings.get('DispatchLateCriticalMins'), 'minutes').format('X'))
        let pickupTime115 = parseInt(pickupTime.clone().subtract(this.$settings.get('DispatchLateWarningMins'), 'minutes').format('X'))
        if (pickupTime1 <= currentTime || pickupTime115 <= currentTime) {
          self.$nextTick(() => {
            self.dispatchStatusChecker()
          })
        }
      }

      if (self.timerDelay) {
        clearTimeout(self.timerDelay)
      }
      self.timerDelay = setTimeout(function () {
        self.runTimer()
      }, 5000)
    },
    closeEmailRecipientModal () {
      if (this.customEmailLoading) { return }
      this.customEmailRecipient = ''
      this.$store.commit('rsvpDetails/setEmailRecipientField', {
        field: 'show',
        value: false
      })
    },
    emailRecipientSelect (target) {
      this.$store.commit('rsvpDetails/setEmailRecipientField', {
        field: 'selected',
        value: target
      })
    },
    updateCustomEmailRecipient () {
      if (this.emailRecipientModal.selected === 'custom') {
        this.$store.commit('rsvpDetails/setEmailRecipientField', {
          field: 'email',
          value: this.customEmailRecipient
        })
      }
    },
    submitEmailRecipient () {
      if (this.customEmailLoading) { return }
      let self = this
      if (self.emailRecipientModal.selected === 'custom'){
        if (!self.customEmailRecipient) {
          self.customEmailFieldError = 'This field cannot be empty.'
          return
        }
        let emailFormat = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/ // eslint-disable-line
        if (!emailFormat.test(self.customEmailRecipient)) {
          self.customEmailFieldError = 'Invalid email format.'
          return
        }
      }

      self.customEmailLoading = true
      self.$sdk.post('/admin/rsvp/' + self.$store.state.rsvpDetails.rsvpId + '/email', {
        token: self.$store.state.session.sessionToken,
        email: self.emailRecipientModal.email
      }, res => {
        self.customEmailFieldError = ''
        self.customEmailLoading = false
        self.$store.commit('rsvpDetails/setEmailRecipientField', {
          field: 'show',
          value: false
        })

        self.noRelog = true 
        if (res.error) {
          self.$store.commit('rsvpDetails/setSendEmail', {
            show: true,
            message: res.error.message
          })
        } else {
          self.$store.commit('rsvpDetails/setSendEmail', {
            show: true,
            message: self.$t('rsvpDetails.emailSent')
          })
        }
      })
    },
    optinServiceConvert (x) {
      let self = this
      let msg = 'Converting back to exclusive service.'
      let url = `/admin/rsvp/${self.rsvpId}/optin/exclusive`
      if (x === 'exclusive') {
        msg = 'Converting to shared service.'
        url = `/admin/rsvp/${self.rsvpId}/optin/shared`
      }

      self.optinModal = false
      self.$store.commit('global/setLoaderData', {
        show: true,
        message: msg
      })
      self.$sdk.post(url, {token: self.$store.state.session.sessionToken}, r => {
        self.$store.commit('global/setLoaderData', {show: false})
        if (r.error) {
          self.$store.commit('global/setAlertData', {
            show: true,
            message: r.error.message
          })
          return
        }
        location.reload();
      })
    },
    getMtechData () {
      let self = this

      self.mtechData.loading = true
      self.$sdk.get(`/admin/rsvp/${self.rsvpId}/mtech`, {
        token: self.$store.state.session.sessionToken
      }, res => {
        self.mtechData.loading = false
        if (!res.error) {
          self.mtechData.id = res.mtechId
        }
      }, '1.1')
    },
    applyCurrency (x) {
      x = parseFloat(x)
      x = x * this.currency.currencyRate
      // return `${this.currency.symbol}${x.toFixed(2)}`
      return xcurrency.format({
        code: this.currency.currency,
        val: x.toFixed(2)
      })
    },
    getCurrencyList () {
      let self = this
      self.$store.commit('global/setLoaderData', {show: true, message: ''})
      
      ApiRsvp.getCurrencyList(self, function () {
        self.$store.commit('global/setLoaderData', {show: false, message: ''})
        self.$store.commit('rsvpDetails/setEditCurrency', {
          code: 'USD',
          symbol: '$',
          value: 1
        })
        if (self.$refs.edit.initNewRsvp()) { self.$refs.edit.initNewRsvp() }
      }, {})
    },
    getLyftServices () {
      let self = this
      if (Object.keys(self.lyftStore.services).length) {
        self.getLyftData()
        return
      }
      self.$sdk.get(`/service/lyft`, {}, r => {
        if (!r.error) {
          self.$store.commit('lyft/setLyftData', {services: r})
        }
        self.getLyftData()
      }, '2.0')
    },
    getLyftData () {
      let self = this
      self.$store.commit('rsvpDetails/setLyftData', {show: false})
      self.$sdk.get(`/admin/rsvp/${self.rsvpId}/lyft`, {
        token: self.$store.state.session.sessionToken
      }, r => {
        if (r.error || !r.rideId) return
        if (!r.lyft) {
          self.$store.commit('rsvpDetails/setLyftData', {
            show: true,
            date: '',
            rideId: r.rideId || '',
            rideType: r.rideType || '',
            driver: {}
          })
          return
        }

        self.$store.commit('rsvpDetails/setLyftData', {
          show: true,
          date: r.lyft && r.lyft.createdUTC ? moment(r.lyft.createdUTC).format('MM/DD/YYYY hh:mmA') : '',
          rideId: r.rideId || r.lyft.rideId,
          rideType: r.rideType || r.lyft.rideType,
          driver: r.lyft && r.lyft.driver && Object.keys(r.lyft.driver).length ? r.lyft.driver : {},
          routeUrl: r.lyft && r.lyft.route_url ? r.lyft.route_url : ''
        })
      }, '1.1')
    },
    showOverrideModal () {
      this.closeBreakdown()
      this.overrideModal.show = true
    },
    backToPaymentBreakdown () {
      this.$store.commit('rsvpDetails/setShowPaymentBreakdown', value)
      this.overrideModal.show = false
      this.overrideModal.value = ''
    },
    submitDriverPaymentOverride () {
      let self = this
      if (self.overrideModal.value === '') {
        self.$store.commit('global/setAlertData', {
          show: true,
          message: 'Price override cannot be empty.'
        })
        return
      }
      self.$store.commit('global/setLoaderData', {show: true})
      self.overrideModal.show = false
      self.$sdk.get('/utils/dp', {
        rsvpId: self.rsvpId,
        amount: self.overrideModal.value
      }, r => {
        if (r.error) {
          self.$store.commit('global/setLoaderData', {show: false})
          self.$store.commit('global/setAlertData', {
            show: true,
            message: r.error.message
          })
          self.overrideModal.show = true
          return
        }
        window.location.reload()
      }, '')
    }
  },
  watch: {
    editEnabled: function (val) {
      let self = this
      if (!val) { self.showIconLog = true }

      setTimeout(function () {
        self.hereMaps.map.getViewPort().resize()
      }, 600)
    },
    showReleaseModal: function (val) {
      if (!val) { return }

      let self = this
      if (self.release.loading) { return }

      self.release.loading = true
      self.release.showContent = false
      self.release.error.show = false
      self.release.charge = 1

      driverRelease.getReleaseFee(self, {
        id: self.rsvpId,
        type: 'rsvp'
      }, function (r) {
        self.release.loading = false

        if (r.error) {
          self.release.error.show = true
          self.release.error.message = r.error.message
          return
        }

        self.release.fee = parseFloat(r.Charge)
        if (self.release.fee === 0) {
          self.release.charge = 0
        }
        self.release.showContent = true
      })
    },
    showFlightStatus: function (value) {
      if (!value) { return }
      this.updateFlightStatus()
    },
    rsvpId: function (value) {
      let self = this
      this.$store.commit('rsvpDetails/setSuggestedTime', '')
      this.$store.commit('rsvpDetails/setCharterData', {enabled: false})
      this.mtechData.id = ''
      if (value !== 'new') {
        this.$store.commit('rsvpDetails/setIsAdd', false)
        for (let object of self.hereMaps.map.getObjects()) {
          self.hereMaps.map.removeObject(object)
        }
        self.hereMaps.ui.getBubbles().forEach(bub => {
          self.hereMaps.ui.removeBubble(bub)
        })
        this.init()

        if (!this.showRightPanel && this.lastRsvpId != value) {
          this.lastRsvpId = value
          if (this.$refs.actionLogs.init()) {
            this.$refs.actionLogs.init()
          }
        }

      } else {
        window.location.reload()
        this.$store.commit('rsvpDetails/setIsAdd', true)
        // this.initNewRsvp()
      }
    },
    rsvpAction: function (value) {
      if (value.show) {
        this.init()
        if (this.$refs.notes.init()) { this.$refs.notes.init() }
        if (this.$refs.transactions.init()) { this.$refs.transactions.init() }
      }
    },
    rsvpEditLocation: function (value) {
      let self = this
      if (self.editEnabled) {
        let mapData = {
          ID: value.id,
          pickupLocation: value.pickup,
          dropoffLocation: value.dropoff
        }
        if (self.extraStops) {
          if (self.extraStops.length) {
            mapData.extraStops = []
            self.extraStops.forEach(stop => {
              mapData.extraStops.push(stop)
            })
          }
        }
        self.showPinLocation(mapData)
        // self.setCenter()
      }
    },
    suggestedTime: function (value) { this.checkSuggestedTime() },
    _flightNo: function (value) { this.checkSuggestedTime() },
    _selectedService: function (value) {
      let currentSelected = value === 'shared'
      if (this.lastSeleted !== currentSelected) {
        this.lastSeleted = currentSelected
        this.checkSuggestedTime()
      }
    },
    rtgSuccess: function (value) {
      if (value) {
        this.$store.commit('dispatch/setReadyToGoSuccess', false)
        location.reload()
      }
    },
    rsvpDetails: function (value) {
      let self = this

      // Render fix
      self.renderFix = false
      self.$nextTick(function () {
        self.renderFix = true
        self.dispatchStatusChecker()
      })

      self.hereMaps.ui.getBubbles().forEach(bub => {
        self.hereMaps.ui.removeBubble(bub)
      })

      if (value && value.tripInfo.id !== '') {
        let tripInfo = value.tripInfo
        let session = self.$store.state.session

        let destination = { lat: tripInfo.pickup.lat, lng: tripInfo.pickup.lng, target: 'pickup' }
        if (tripInfo.status === 'onboard') {
          destination = { lat: tripInfo.dropoff.lat, lng: tripInfo.dropoff.lng, target: 'dropoff' }
        }

        let dateFormat = 'MM/DD/YYYY hh:mmA'
        dateFormat = self.$settings.get('MilitaryTimeBackoffice') === '1' ? 'MM/DD/YYYY HH:mm' : 'MM/DD/YYYY hh:mmA'

        if ((tripInfo.bidStatus === 'dispatched' &&
          ['upcoming', 'ontheway', 'arrived'].indexOf(tripInfo.status) > -1) ||
          ['onboard', 'complete'].indexOf(tripInfo.status) > -1
        ) {
          self.$sdk.get('/provider/' + value.driverInfo.id + '/tracks', {token: session.sessionToken}, res => {
            if (!res.error && res.list.length) {
              self.driverInMap = { lat: res.list[0].lat, lng: res.list[0].lng }
              if (self.infoWindows[2]) { self.infoWindows.splice(2, 1) }
              self.infoWindows.push({
                lat: res.list[0].lat,
                lng: res.list[0].lng,
                type: 'vehicle',
                opened: true,
                distance: 0
              })

              let heading = null
              if (res.list[0].heading !== null) {
                heading = parseInt(res.list[0].heading)
              }
              if (isNaN(heading) || heading < 0 || heading > 359) {
                if (self.rsvpStatus !== 'ONBOARD' && self.driverInMap && self.rsvpInMap && self.rsvpInMap.pickup) {
                  heading = self.computeHeading(self.driverInMap, self.rsvpInMap.pickup)
                } else if (self.driverInMap && self.rsvpInMap && self.rsvpInMap.dropoff) {
                  heading = self.computeHeading(self.driverInMap, self.rsvpInMap.dropoff)
                }
              }
              self.calculateRoute(
                self.driverInMap,
                destination,
                { type: 'driverRoute', pathOnly: false, etaOnly: false }
              )
              res.list[0].heading = heading - 90
              self.addMarker(res.list[0], 'car')

              if (self.infoWindows[2]) {
                self.infoWindows[2].lat = res.list[0].lat
                self.infoWindows[2].lng = res.list[0].lng
                self.infoWindows[2].type = 'vehicle'
              }

              if (['canceled', 'complete'].indexOf(tripInfo.status) > -1) {
                self.infoWindows.splice(2, 1)
              }
            }
          })
        }

        if ((tripInfo.bidStatus === 'dispatched' &&
          ['ontheway', 'arrived'].indexOf(tripInfo.status) > -1) ||
          ['onboard', 'complete'].indexOf(tripInfo.status) > -1
        ) {
          self.$sdk.get('/admin/rsvp/' + self.rsvpId + '/locations', {token: session.sessionToken}, res => {
            if (!res.error && res.list.length) {
              self.extraPins = []
              res.list.forEach(data => {
                data.created = moment(data.created, 'YYYY-MM-DD@HH:mm:ss').format(dateFormat)
                data.opened = false
                if (data.status !== 'onboard') {
                  if (data.lat !== 0 && data.lng !== 0) {
                    self.extraPins.push(data)
                  }
                }
              })
              let tmpPins = []
              if (tripInfo.status === 'ontheway') {
                let otwIndex = res.list.findIndex(x => x.status === 'ontheway')
                tmpPins.push(res.list[otwIndex])
              }
              if (tripInfo.status === 'arrived') {
                let otwIndex = res.list.findIndex(x => x.status === 'ontheway')
                let arrivedIndex = res.list.findIndex(x => x.status === 'arrived')
                tmpPins.push(res.list[otwIndex])
                tmpPins.push(res.list[arrivedIndex])
              }
              if (tripInfo.status === 'onboard') {
                let otwIndex = res.list.findIndex(x => x.status === 'ontheway')
                let arrivedIndex = res.list.findIndex(x => x.status === 'arrived')
                tmpPins.push(res.list[otwIndex])
                tmpPins.push(res.list[arrivedIndex])
              }
              if (tripInfo.status === 'complete') {
                tmpPins = self.extraPins
              }
              self.extraPins = tmpPins

              let heading = null
              if (res.list[0].heading !== null) {
                heading = parseInt(res.list[0].heading)
              }
              if (isNaN(heading) || heading < 0 || heading > 359) {
                if (self.rsvpStatus !== 'ONBOARD') {
                  heading = self.computeHeading(self.driverInMap, self.rsvpInMap.pickup)
                } else {
                  heading = self.computeHeading(self.driverInMap, self.rsvpInMap.dropoff)
                }
              }

              let showEta = ['arrived', 'complete'].indexOf(tripInfo.status) === -1
              // let createdDate = moment(res.list[0].created, 'YYYY-MM-DD@HH:mm:ss')
              let createdDate = moment(res.list[0].created, 'MM/DD/YYYY hh:mmA')

              if (tripInfo.status === 'onboard') {
                // self.infoWindows[0].arrived = createdDate.format(dateFormat)
              } else if (tripInfo.status === 'complete') {
                // self.infoWindows[0].arrived = moment(res.list[1].created, 'YYYY-MM-DD@HH:mm:ss').format(dateFormat)
                // self.infoWindows[0].completed = createdDate.format(dateFormat)
                self.driverInMap = null
              }

              if (res.list.length > 1) {
                let onthewayIndex = res.list.findIndex(x => x.status === 'ontheway')
                let arrivedIndex = res.list.findIndex(x => x.status === 'arrived')
                if (onthewayIndex !== -1 && arrivedIndex !== -1 && tripInfo.status !== 'ontheway' &&
                  res.list[onthewayIndex].lat && res.list[onthewayIndex].lng &&
                  res.list[arrivedIndex].lat && res.list[arrivedIndex].lng
                ) {
                  self.calculateRoute(
                    { lat: res.list[onthewayIndex].lat, lng: res.list[onthewayIndex].lng },
                    { lat: res.list[arrivedIndex].lat, lng: res.list[arrivedIndex].lng },
                    { type: 'extraRoute', pathOnly: true, etaOnly: false }
                  )
                }
                let completedIndex = res.list.findIndex(x => x.status === 'completed')
                if (completedIndex !== -1 &&
                  res.list[arrivedIndex].lat && res.list[arrivedIndex].lng &&
                  res.list[completedIndex].lat && res.list[completedIndex].lng
                ) {
                  self.calculateRoute(
                    { lat: res.list[arrivedIndex].lat, lng: res.list[arrivedIndex].lng },
                    { lat: res.list[completedIndex].lat, lng: res.list[completedIndex].lng },
                    { type: 'completedRoute', pathOnly: true, etaOnly: false }
                  )
                }
              }

              if (['canceled', 'complete'].indexOf(tripInfo.status) > -1) {
                self.infoWindows.splice(2, 1)
              }

              if (self.extraPins.length) {
                self.extraPins[self.extraPins.length - 1].opened = true
              }

              self.extraPins.forEach(pin => {
                self.addMarker(pin, 'extra')
              })
            }
          })
        }

        if (tripInfo.status === 'canceled') {
          self.$sdk.get('/admin/rsvp/' + self.rsvpId + '/locations', {token: session.sessionToken}, res => {
            if (!res.error && res.list.length) {
              self.extraPins = []
              res.list.forEach(data => {
                let statusLabel = ''
                if (data.status === 'ontheway') { statusLabel = 'PROVIDER On the way' }
                if (data.status === 'arrived') { statusLabel = 'PROVIDER Arrived' }
                if (data.status === 'onboard') { statusLabel = 'CONSUMER On Board' }

                self.cancelData.push({
                  status: data.status,
                  label: statusLabel,
                  date: moment(data.created, 'YYYY-MM-DD@HH:mm:ss').format(dateFormat)
                })

                data.created = moment(data.created, 'YYYY-MM-DD@HH:mm:ss').format(dateFormat)
                data.opened = false
                if (data.status !== 'onboard') {
                  if (data.lat !== 0 && data.lng !== 0) {
                    self.extraPins.push(data)
                  }
                }
              })
              if (self.extraPins.length) {
                self.extraPins[self.extraPins.length - 1].opened = true
              }
            }
          })
        }

      }
    },
    'emailRecipientModal.selected': function (val) {
      let email = val === 'custom' ? this.customEmailRecipient : this.rsvpDetails.customerInfo.email
      this.$store.commit('rsvpDetails/setEmailRecipientField', {
        field: 'email',
        value: email
      })
    },
    _updateMap (val) {
      let self = this
      if (val) {
        self.$store.commit('rsvpDetails/setUpdateMap', false)
        let mapData = {
          ID: self.rsvpEditLocation.id,
          pickupLocation: self.rsvpEditLocation.pickup,
          dropoffLocation: self.rsvpEditLocation.dropoff
        }
        if (self.extraStops) {
          if (self.extraStops.length) {
            mapData.extraStops = []
            self.extraStops.forEach(stop => {
              mapData.extraStops.push(stop)
            })
          }
        }
        self.showPinLocation(mapData)
      }
    },
    totalDriverPayment (x) {
      this.overrideModal.value = x
    }
  },
  created: function () {
    Vue.component('here-info-bubble-car', {
      template: `<div class="here-info-window car">
        <div class="left">
          <img :src="driverPhoto" />
          <a :href="driverUrl" target="_blank"><span>{{driverName}}</span></a>
          <span class="sub-text">{{distance}}{{eta}}</span>
        </div>
        <div class="right"><img :src="vehiclePhoto" /><span class="model">{{model}}</span>
        <span class="sub-text">{{license}}</span></div>
        <a :class="{'button cta xsmall success block':true, 'disabled':hasOngoingCall}" @click="callDriver"><i class="fas fa-phone"></i>
        <span>{{call}}</span></a>
      </div>`,
      data () {
        return {
          driverInfo: '',
          driverPhoto: '',
          driverUrl: '',
          driverName: '',
          distance: '',
          eta: '',
          vehiclePhoto: '',
          model: '',
          license: '',
          call: ''
        }
      },
      computed: {
        hasOngoingCall () { return this.$store.state.phone.ongoing }
      },
      methods: {
        update (data) {
          this.driverInfo = data.driverInfo
          this.driverPhoto = data.driverPhoto
          this.driverUrl = data.driverUrl
          this.driverName = data.driverName
          // this.distance = data.distance
          this.eta = data.eta
          this.vehiclePhoto = data.vehiclePhoto
          this.model = data.model
          this.license = data.license
          this.call = data.call
        },
        updateField (data) {
          this[data.field] = data.value
        },
        callDriver () {
          let self = this
          self.$plugins.phone.startCall(self, {
            phone: self.driverInfo.mobile,
            name: self.driverInfo.firstName + ' ' + self.driverInfo.lastName
          })
        }
      }
    })

    Vue.component('here-info-bubble-pickup', {
      template: `<div class="here-info-window pickup">
        <div class="location">
          <span v-if="onEdit">{{ rsvpDetails.edit.details.tripInfo.pickup.title }}</span>
          <span v-else>{{ rsvpDetails.basicInfo.tripInfo.pickup.title }}</span>
        </div>
        <div class="eta" v-if="infoWindow.eta && ['canceled', 'complete'].indexOf(rsvpDetails.basicInfo.tripInfo.status) === -1">
          <label>ETA:</label>
          <b>{{ infoWindow.eta }}</b>
        </div>
      </div>`,
      data () {
        return {
          infoWindow: {},
          onEdit: false
        }
      },
      computed: {
        rsvpDetails () { return this.$store.state.rsvpDetails }
      },
      methods: {
        update (data) { this.infoWindow = data },
        editMode (val) { this.onEdit = val }
      }
    })

    Vue.component('here-info-bubble-dropoff', {
      template: `<div class="here-info-window dropoff">
        <div class="location">
          <span v-if="onEdit">{{ rsvpDetails.edit.details.tripInfo.dropoff.title }}</span>
          <span v-else>{{ rsvpDetails.basicInfo.tripInfo.dropoff.title }}</span>
        </div>
        <div class="eta" v-if="infoWindow.eta && ['canceled', 'complete'].indexOf(rsvpDetails.tripInfo.status) === -1">
          <label>ETA:</label>
          <b>{{ infoWindow.eta }}</b>
        </div>
      </div>`,
      data () {
        return {
          infoWindow: {},
          onEdit: false
        }
      },
      computed: {
        rsvpDetails () { return this.$store.state.rsvpDetails }
      },
      methods: {
        update (data) { this.infoWindow = data },
        editMode (val) { this.onEdit = val }
      }
    })

    Vue.component('here-info-bubble-extra-stop', {
      template: `<div class="here-info-window pickup">
        <div class="location">
          <span v-if="onEdit">
            <span v-if="rsvpDetails.edit.details.tripInfo.extraStops && rsvpDetails.edit.details.tripInfo.extraStops.length">
              {{ extraStopAddress(rsvpDetails.edit.details.tripInfo.extraStops[index]) }}
            </span>
          </span>
          <span v-else>{{ extraStopAddress(rsvpDetails.extraStops[index]) }}</span>
        </div>
      </div>`,
      props: ['onEdit', 'index'],
      data () {
        return {
          infoWindow: {}
          // onEdit: false
        }
      },
      computed: {
        rsvpDetails () { return this.$store.state.rsvpDetails }
      },
      methods: {
        update (data) { this.infoWindow = data },
        editMode (val) { this.onEdit = val },
        extraStopAddress (x) {
          return x ? `${x.address2} ${x.address1}, ${x.city}, ${x.state} ${x.zipCode}` : ''
        }
      }
    })
  },
  mounted () {
    if (this.$route.params.id !== 'new') {
      this.$store.commit('rsvpDetails/setIsAdd', false)
      this.init()
    } else {
      if (!this.$store.state.session.user.access.hasOwnProperty('PageAdminRSVPAdd')) {
        this.$router.push('/thispagedoesnotexist')
        return
      }

      this.$store.commit('rsvpDetails/setIsAdd', true)
      this.initNewRsvp()
    }
    this.initMap()

    let self = this
    self.$store.commit('rsvpDetails/resetDispatchLogs')
    ApiRsvpDispatch.getDispatchLogs(self, self.$route.params.id, function (res) {
    })
    if (self.$store.state.settings.sharedAllowedTime.start === '') {
      request.get({
        url: CONFIG.Gateway.url + '/appsettings',
        json: true
      }, function (err, res, body) {
        self.$store.commit('settings/setAdminTimeBuffer', parseInt(body.AdminTimeBuffer))
        let minDurationServiceId = []
        if (body.CharterMinServiceTypeIds) {
          minDurationServiceId = body.CharterMinServiceTypeIds.replaceAll(' ', '').split(',')
          minDurationServiceId = minDurationServiceId.filter(x => x)
        }
        self.$store.commit('settings/setSettings', {
          optinAllowedTime: {
            start: body.OptinAirportStart,
            end: body.OptinAirportEnd
          },
          charterMaxDura: body.CharterMaxDuration,
          charterMinDuration: body.CharterMinDuration,
          charterMnDurationServiceId: minDurationServiceId
        })
        self.$store.commit('settings/setSharedAllowedTime', {
          start: body.AirportStart,
          end: body.AirportEnd
        })
        self.$store.commit('routing/setBeThereTimeThreshold', 1 + (parseFloat(body.OfferLimitThreshold) / 100))
      })
    }

    if (!self.$store.state.services.list.length) {
      self.$store.commit('services/setServiceLoading', true)
      ApiServices.getAllService(self, r => {
        self.$store.commit('services/setServiceLoading', false)
      })
    }

    this.runTimer()
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/_status';

* { -webkit-overflow-scrolling: touch; }

$left-panel-width: 652px;
$right-panel-width: 400px;
$fixed-bottom-height: 60px;

.route-map,
.left-panel,
.right-panel,
.fixed-bottom
{ transition: all .6s ease; }

$toggle-size: 50px;

.logs-toggle {
  position: fixed;
  right: 0;
  top: 0;
  z-index: 3;
  width: $toggle-size;
  height: $toggle-size;
  line-height: $toggle-size;
  text-align: center;
  color: #777;
  transition: all 250ms;
  border-radius: 0;
  background-color: #F25E0D;
  color: #fff;
  border-bottom-left-radius: 3px;
  box-shadow: -2px 0 8px rgba(0,0,0,0.35);
  cursor: pointer;
  -webkit-transform: rotate(90deg);
  -moz-transform: rotate(90deg);
  -o-transform: rotate(90deg);
  transform: rotate(90deg);
  -webkit-transition: .5s ease;
  -moz-transition: .5s ease;
  -o-transition: .5s ease;
  transition: .5s ease;

  & i { line-height: inherit; }

  &.on{
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
    -webkit-transition: .5s ease;
    -moz-transition: .5s ease;
    -o-transition: .5s ease;
    transition: .5s ease;
  }

}

.route-map{
  position: fixed;
  top: 0;
  left: $left-panel-width;
  width: calc(100% - (#{$left-panel-width}));
  // width: 80%;
  height: 100%;
  z-index: 1;
  display: none; /* ADDED */
}

.map-here{
  position: fixed;
  top: 0;
  left: $left-panel-width;
  width: calc(100% - (#{$left-panel-width}));
  height: 100%;
  z-index: 1;
}

.map-box{
  position: fixed;
  top: 0;
  left: $left-panel-width;
  width: calc(100% - (#{$left-panel-width}));
  height: 100%;
  z-index: 2;

  .legend, .cancel-data-box{
    position: absolute;
    bottom: 15px;
    right: 15px;
    background: #fff;
    border: 1px solid #999;
    padding: 5px 10px;
    z-index: 2;
    box-shadow: 0 0 4px rgba(0,0,0, .5);
    border-radius: 2px;

    ul{
      list-style-type: none;
      margin: 0;
      padding: 0;

      .icon{
        display: inline-block;
        border:1px solid #777;
        width: 12px;
        height: 12px;
        vertical-align: -1px;
        border-radius: 2px;

        &.pickup{ background: #2ee47d; }
        &.extra-stop{ background: #fe8214; }
        &.dropoff{ background: #ca3538; }
        &.ontheway{ background: #dbd935; }
        &.arrived, &.onboard{ background: #389ce1; }
        &.completed{ background: #1ac1b1; }
        &.canceled{ background: #bbb; }
      }
    }
  }

  .legend ul{
    li{
      display: inline-block;
      padding-right: 15px;

      &:last-child{ padding-right: 0; }
      span{
        font-size: 13px;
        color: #333;
      }
    }
  }

  .cancel-data-box{
    font-size: 13px;

    li{
      display: block;
      margin-bottom: 3px;
    }
    label{
      color: #999;
      margin-right: 5px;
      div { margin-right: 4px; }
    }
    span{
      font-weight: 600;
      color: #444;
    }
  }
}

.render-loader{
  position: fixed;
  z-index: 2;
  bottom: 20px;
  right: 20px;

  & .map-loading{
    color: #fff;
    font-size: 12px;
    font-weight: 700;
    background-color: #F25E0D;
    padding: 5px 10px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.35);
  }
}

.heading{
  // height: 50px;
  font-weight: 600;
  color: #333;
  padding: 10px 0;

  span{ margin-left: 15px; }
  .label{
    font-size: 20px;
    line-height: 100%;
    display: block;
  }
  .edit, .rtg{
    float: right;
    margin-right: 5px;
  }
  .cxl-reason{
    margin-left: 2px;
    font-size: 12px;
    color: #777;
    display: inline-block;
    width: 480px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    vertical-align: middle;
  }
  .track-link{
    font-size: 12px;
    letter-spacing: .7px;
    margin-left: 5px;
  }
  .lyft-link{
    color: #ff00bf;
  }
}
.mtech-id{
  margin-left: 0!important;
  color: #7a878a;
  font-size: 16px;
  display: block;
  span{
    margin-left: 1px;
  }
}

.status{
  &.ready{ background: #6dabc3; }
  &.accepted{ background: #777; }
  &.on-time{ background: #26d97a; }
  &.late{ background: #dc9831; }
  &.ontheway{ background: #f38d56; }
  &.very-late{ background: #e62e2e; }
  &.open-credit{ background: #29c3c3; }
}

.left-panel{
  position: fixed;
  z-index: 2;
  left: 0;
  top: 0;
  width: $left-panel-width;
  height: 100%;
  box-shadow: 2px 0 4px rgba(0,0,0,0.2);
  background-color: #F4F8F9;
  overflow-y: auto;
  padding-bottom: $fixed-bottom-height;

  .heading{ padding-left: 50px; }

  .tab li{ width: 33.3%; }

  .toggle-mobile {
    display: none;
  }
}

.tab{
  list-style: none;
  padding: 0;
  margin: 15px 0 0;
  display: flex;
  position: relative;
  z-index: 2;

  li{
    color: #0D79F2;
    padding: 15px 25px;
    font-size: 14px;
    font-weight: 600;
    text-align: center;
    display: inline-block;
    text-transform: uppercase;
    cursor: pointer;
    line-height: 1.3;

    &.active{
      background: #fff;
      box-shadow: 0 -1px 2px rgba(0,0,0, .1);
      border-radius: 2px 2px 0 0;
      color: #777;
    }
    &.disabled{
      color: #ccc;
      cursor: default;
    }
  }
}

.tab-contents{
  background: #fff;
  z-index: 1;
  position: relative;
  box-shadow: 0 0 2px 1px rgba(0,0,0, .1);

  .tab-content{
    padding: 20px 20px 50px;
    display: none;

    &.no-H-padding{ padding: 20px 0; }
    &.active{
      display: block;
    }
  }

  .dispatch-log {
    padding-bottom: 80px;
  }
}

.right-panel{
  position: fixed;
  z-index: 2;
  right: 0;
  top: 0;
  width: $right-panel-width;
  height: 100%;
  box-shadow: -2px 0 4px rgba(0,0,0,0.2);
  background-color: #f4f8f9;
  // overflow-y: auto;

  &.hide{
    right: -#{$right-panel-width};
    box-shadow: -2px 0 8px rgba(0,0,0,0.0);
  }

  .heading{
    font-size:24px;
    padding: 10px 20px;
    margin-bottom: 7px;
  }

  .tab{
    background: #d5d5d5;
    & .active{ background: #fff; }
    li {
      width: 50%;
      background-color: #f4f8f9;
    }
  }
  .tab-contents{
    background: #fff;
    display: block;
    height: calc(100% - 57px);
    overflow-y: auto;
  }
}

.fixed-bottom{
  position: fixed;
  bottom: 0;
  left: 0;
  width: $left-panel-width;
  height: $fixed-bottom-height;
  z-index: 3;
  background: #eee;
  padding: 10px 15px 10px 10px;
  display: flex;
  justify-content: center;
  box-shadow: 0 -1px 2px rgba(0,0,0, .25);

  a{
    width: 50%;
    margin: 0 5px;

    &.right{ margin-left: auto; }
    &.create{ margin: 0 auto; }
  }
}

.modal{
  position: fixed;
  z-index: 12;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: none;
  flex-direction: column;
  justify-content: center;
  resize: vertical;

  .bg-overlay{
    position: absolute;
    z-index: 1;
    background: rgba(0, 0, 0, 0.5);
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
  }
  .modal-content{
    position: relative;
    z-index: 2;
    background: #fff;
    width: 400px;
    min-height: 150px;
    border-radius: 6px;
    padding: 20px;
    margin: auto;
    box-shadow: 1px 1px 5px 1px rgba(0,0,0, .3);
    display: none;
  }
  &.show{
    display: flex;

    .modal-content{
      display: block;
      -webkit-animation: slide-down .15s ease-out;
      -moz-animation: slide-down .15s ease-out;
    }
  }
}

.breakdown{
  .head{
    text-align: center;
    font-size:18px;
    font-weight: 600;
    color: #555;
    display: block;
    padding-bottom: 3px;
    border-bottom: 1px solid #ddd;
    margin-bottom: 10px;

    &.d-flex{
      text-align: left;
      display: flex;
    }
  }
  .item{
    font-size: 15px;
    margin-bottom:5px;
    .label{
      color: #777;
      text-transform: uppercase;
    }
    .value{
      float:right;
      font-weight: 600;
    }
  }
  .button{ margin-top:20px; }
  .op-link{
    font-size: 13px;
    color: #4da1ff;;
    font-weight: 500;
    cursor: pointer;
  }
}

.flightStatusModal{
  text-align: center;

  .loading{
    padding: 30px 0;
    font-size: 21px;
    color: #555;
    .fa{
      color: #0D79F2;
    }
  }
  span{
    display: block;
    line-height: 1;
  }
  .label{
    font-size: 12px;
    color: #999;
    text-transform: uppercase;
  }
  .value{
    color: #555;
    font-weight: 600;
    font-size: 18px;
    margin: 2px 0 20px;
  }
}

.flight-error{
  padding: 20px 0 30px;
  .fa{
    color: #ccc;
    margin-bottom: 10px;
  }
  .title{
    font-size:24px;
    color: #aaa;
    font-weight: 600;
    margin-bottom: 5px;
  }
  .body{
    font-style: italic;
    color: #333;
    font-size: 14px;
  }
}

.try-again{ margin-bottom:8px; }

@-webkit-keyframes slide-down {
  0% { opacity: 0; -webkit-transform: translateY(100%); }
  100% { opacity: 1; -webkit-transform: translateY(0); }
}
@-moz-keyframes slide-down {
  0% { opacity: 0; -moz-transform: translateY(100%); }
  100% { opacity: 1; -moz-transform: translateY(0); }
}

.email-result{
  text-align: center;
  p{ font-size: 18px; }
  .header{
    display: block;
    font-weight: 600;
    color: #333;
    margin-bottom: 10px;
  }
  .body{
    display: block;
    font-size: 14px;
    color: #444;
    margin-bottom: 30px;
  }
  .cancel{
    font-size: 14px;
    margin: 10px 0 0;
    display: block;
    cursor: pointer;
  }
}

.release-modal {
  position: fixed;
  z-index: 999;
  top: -100%;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.3);
  display: table;
  opacity: 0;
  transition: all 250ms;

  &.show{
    top: 0;
    opacity: 1;
  }
}

.release-modal-container {
  display: table-cell;
  vertical-align: middle;
}

.release-modal-content {
  background-color: #fff;
  border-radius: 3px;
  max-width: 400px;
  margin: 0 auto;
  box-shadow: 0 2px 8px rgba(0,0,0,0.35);
  text-align: center;
  overflow: hidden;

  & .title {
    font-weight: 700;
    background-color: #333;
    color: #fff;
    padding: 10px;
  }

  .loading, .error{
    text-align: center;
    padding: 25px 0;
  }
  .loading{
    i{ color: #4fa1f7; }
    div{ color: #999; }
  }

  .error{
    i{ color: #f3e26d; }
    div{
      color: #777;
      margin-top: 15px;
    }
  }

  .fee{
    padding: 10px;
    margin: 0 10px 20px;
    background: #f7eeb2;
    border: 1px solid #d0be42;
    border-radius: 10px;
    color: #444;
    box-shadow: 1px 1px 3px rgba(0,0,0, .1);

    p{
      margin: 0 0 5px;
      font-size: 14px;
    }
    label{
      float: left;
      width: 50%;
      font-weight: 600;
    }
    input{
      width: initial;
      display: inline-block;
      margin: 0;
    }
    .clear{ clear:both; }
  }

  & .message {
    padding: 15px;
    font-weight: 700;
    color: #555;
  }

  & .sub-message{
    font-size: 14px;
    padding: 0 15px 15px;
    color: #777;

    & strong {
      color: #555;
      text-decoration: underline;
    }
  }

  & .controls{
    padding: 0px 15px 15px;

    & .padding-R { padding-right: 5px; }
    & .padding-L { padding-left: 5px; }
  }

  & .releasing {
    & .message { padding-top: 10px; }
    & i {
      margin-top: 18px;
      color: #0D79F2;

      &.success { color: #26D97A; }
    }
  }
}

.suggested-time-modal{
  text-align: center;
  width: 450px!important;
  .title{
    font-size: 21px;
    font-weight: 600;
    color: #3c6879;
  }
  p{
    font-size: 15px;
    margin: 10px 0 15px;
  }
  .time{
    display: inline-block;
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 15px;
    border-bottom: 1px solid #24af65;
    color: #24af65;
    word-spacing: 5px;
  }
  .keep{
    display: block;
    margin-top: 10px;
    font-size: 14px;
    color: #999;
    cursor: pointer;
  }
}

.editing{
  .legend {
    display: none;
  }
  .route-map, .map-here{
    width: 30%;
    left: 70%;
  }
  .left-panel, .fixed-bottom{ width: 70%; }
  .right-panel{ right: -$right-panel-width; }
}

.select-user{
  text-align: center;
  width: 500px!important;
  height: 400px;
  padding: 0!important;
  overflow: hidden;
  background: #f8f8f8!important;

  .title{
    background: #444;
    padding: 10px;
    color: #fff;
  }
  .box{ padding: 10px; }
  .search-input{
    margin: 0 0 10px;
    font-size: 14px;
    box-shadow: 1px 1px 1px rgba(0,0,0, .07);
  }
  .box-list{ position: relative; }
  .loader{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0, .7);
    color: #fff;

    i{
      vertical-align: middle;
      margin-right: 5px;
    }
    .v-center{
      text-align: center;
      width: 100%;
      position: absolute;
      top: 50%;
      -ms-transform: translateY(-50%);
      transform: translateY(-50%);
    }
  }
  .list{
    display: block;
    margin: 0;
    padding: 0;
    list-style: none;
    border: 1px solid #ddd;
    height: 220px;
    background: #fefefe;
    border-radius: 2px;
    box-shadow: 1px 1px 1px rgba(0,0,0, .07);
    overflow: auto;

    li{
      text-align: left;
      padding: 8px;
      border-bottom: 1px solid #ddd;
      cursor: pointer;

      &:hover{ background:#fffbe7; }
      .name{
        font-size:14px;
        display: inline-block;
        font-weight: 600;
      }
      .id{
        display: inline-block;
        width: 70px;
        text-align: right;
        color: #333;
        font-size:12px;
      }
      .email, .mobile{
        display: block;
        font-size: 12px;
        line-height: 130%;
        color: #aaa;
      }
      &.disabled{
        cursor: default;
        opacity: .6;
        background: #f3f3f3;

        &:hover{ background: #f3f3f3; }
      }
      .status{
        letter-spacing: .9px;
        background: #888;
      }
    }
  }
  .is-d2d{
    color: #fff;
    padding: 3px 5px;
    line-height: 1;
    background: #444;
    border-radius: 4px;
    font-weight: 600;
    letter-spacing: .8px;
    margin-top: 3px;
    display: inline-block;
  }
  .actions{ margin-top: 10px; }
  .padding-L{ padding-left: 5px; }
  .padding-R{ padding-right: 5px; }
}

.asap-modal{
  max-width: 500px;
  width: 100%!important;
  text-align: center;

  .fa-car{
    color: #999;
    font-size: 40px;
  }
  .fa-spinner{ color: #ccc; }
  .looking-for{
    display: block;
    margin-top: 10px;
  }
  .cancel-asap{
    margin-top: 10px;
    width: 200px;
  }
}

.optin-modal{
  text-align: center;

  label{
    margin-bottom: 20px;
    display: block;
    font-weight: 600;
  }
  .button{
    width: 45%;
  }
}

.select-email-recipient{
  padding: 0!important;
  overflow: hidden;

  .title{
    background: #444;
    padding: 10px;
    color: #fff;
    text-align: center;
  }
  .box{ padding: 20px; }
  .label{
    color: #555;
    font-weight: 600;
  }
  ul{
    list-style: none;
    padding: 0;

    li{
      margin-bottom: 10px;
      font-size: 14px;

      span{ vertical-align: 2px; }
    }
  }
  input{
    margin: 0;

    &[type="radio"]{
      width: auto;
      display: inline-block;
      margin-right: 5px;
      width: 20px;
    }
    &[type="input"]{
      display: inline-block;
      width: calc(100% - 30px);
      padding: 5px;
    }
    &.has-error{ border-color: #f00; }
  }
  .padding-L{ padding-left: 5px; }
  .has-error{
    font-size: 12px;
    color: #f00;
    padding-left: 30px;
    line-height: 1.6;
  }
}

.no-driver{
  .fa-user-circle{ color: #555; }
  .message{
    display: block;
    margin-top: 15px;
    font-size: 14px;
  }
  .change-service{
    margin: 20px 0 5px;
  }
}

.driver-info{
  .info{ margin-bottom: 10px; }
  .title{
    margin-bottom: 20px;
    display: block;
    font-size: 21px;
    color: #555;
    font-weight: 600;
  }
  .img{
    display: inline-block;
    width: 60px;
    margin-right: 20px;
    vertical-align: top;
  }
  .desc{
    display: inline-block;
    width: 320px;
    text-align: left;

    .rating, .name, .model{ font-size: 14px; }
    .email, .plate{
      font-size: 12px;
      color: #999;
    }
    .fa-star{
      color: #d2c52d;
      margin-right: 5px;
    }
  }
  .close-asap{
    margin-top: 20px;
    width: 300px;
  }
}

.create-error{
  text-align: center;

  .fa-exclamation-circle{
    color: #ffd86b;
    margin-bottom: 3px;
  }
  .message{
    font-size: 16px;
    margin-bottom: 15px;
  }
}

.stop-info{
  color: #555;
  .location{ max-width: 300px; }
  .data{
    &.top-line{
      margin-top: 5px;
      padding-top: 5px;
      border-top:1px solid #eee;
    }
    div{ margin-bottom: 2px; }
    label{ color: #999; }
    span{
      word-spacing: 2px;
      font-weight: 500;
    }
  }
}

$photo-size: 70px;
.driver-infowindow{
  position: relative;
  padding: 15px 0 10px 15px;
  width: 400px;

  .photo{
    display: block;
    width: $photo-size;
    height: $photo-size;
    background-color: #ddd;
    margin: 0 auto;
    border-radius: $photo-size;
    box-shadow: inset 0 0 4px rgba(0,0,0,0.5);
    border: 1px solid rgba(0,0,0,0.25);
  }

  .name{
    display: block;
    text-align: center;
    margin-top: 5px;
    font-size: 14px;
    font-weight: 700;
    text-transform: uppercase;
  }

  .subtext{
    text-align: center;
    margin-bottom: 10px;
    font-size: 12px;
    color: #777;
    font-weight: 700;
  }

  .cta{ margin-bottom: 5px; }
}

.down-scale-enter-active, .down-scale-leave-active { transition: all .3s ease; }
.down-scale-enter, .down-scale-leave-to {
  transform: scale(.7) translateY(-10px);
  opacity: 0;
}

.show-up-enter-active, .show-up-leave-active { transition: all .3s ease; }
.show-up-enter, .show-up-leave-to {
  transform: translateY(20px);
  opacity: 0;
}

.slide-up-enter-active, .slide-up-leave-active { transition: all .3s ease; }
.slide-up-enter, .slide-up-leave-to {
  transform: translateY(-10px);
  opacity: 0;
}

.appear-enter-active, .appear-leave-active { transition: all .3s ease; }
.appear-enter, .appear-leave-to {
  transform: scale(.95);
  opacity: 0;
}

@media only screen and (max-width: 430px) {
  .map-box {
    width: 100%;
    z-index: 5;

    #mapHere {
      left: 0;
      width: 100%;
      top: 100%;
      transition: all 0.3s ease;
    }

    &.showMapBox {
      #mapHere {
        top: 0;
      }
    }
  }

  .heading .edit {
    float: none;
    margin: 0;
  }

  .left-panel {
    width: 100%;
    padding-bottom: 85px;
    .edit-btn-div {
      padding-left: 13px;
    }
    .tab {
      margin-top: 50px;
      display: table;

      li {
        padding: 12px 10px;
        vertical-align: middle;
        display: table-cell;
        font-size: 12px
      }
    }

    .fixed-bottom {
      bottom: 40px;
      a.right {
        margin-left: inherit;
      }
      a.create {
        margin: 0 auto;
      }
    }

  }
  .toggle-mobile {
    display: block;
    color: #fff;
    background-color: #333;
    cursor: pointer;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    text-align: center;
    padding: 8px 0;
    height: 45px;
    -webkit-transition: top .25s;
    transition: top .25s;
    z-index: 9;
    text-transform: uppercase;
    font-weight: 900;
  }

  .editing {
    .left-panel,
    .fixed-bottom {
      width: 100%;
    }

    .tab {
      li {
        padding: 5px 13px;
      }
    }

  }
  .tab-contents {
    .tab-content {
      padding: 10px;
    }
  }

  .transaction-tab {
    width: 100%;
  }

  .select-user {
    width: 95vw !important;
    height: auto;
  }

  .right-panel {
    width: calc(100vw - 55px) !important;
  }

  .button.small {
    font-size: 11px;
    width: auto;
    padding: 7px;

    &.btn-close {
      font-size: 14px;
      width: 100%;
    }
  }

  .fixed-bottom {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100vw;
    .button.small {
      font-size: 12px;
      width: auto;
      padding: 7px 15px;

      &.create {
        width: 100%;
        font-size: 16px !important;
      }
    }
    .create {
      font-size: 14px !important;
      padding: 10px 22px !important;
    }
  }

  .modal .modal-content {
    width: 100%;
  }

  .select-email-recipient {
    .medium-6 {
      width: 50%;
      a {
        width: 100%;
      }
    }
  }
}

.lr-tooltip{
  margin-left: 2px;
  display: inline-block;
  position: relative;
  
  .tp-desc{
    transition: all .3s ease;
    position: absolute;
    top: 100%;
    width: 100px;
    background: #fafafa;
    padding: 5px;
    font-size: 12px;
    text-align: center;
    line-height: 1.1;
    border-radius: 4px;
    border: 1px solid #eee;
    left: -50px;
    box-shadow: 1px 1px 2px #ccc;
    opacity: 0;
    z-index: -1;
  }
  &:hover .tp-desc{
    top: calc(100% + 4px);
    opacity: 1;
    z-index: 1;
  }
}
.optin-icon{
  width: 18px;
}

.dpo-field{
  position: relative;

  span{
    position: absolute;
    z-index: 2;
    font-weight: 600;
    color: #666;
    line-height: 46px;
    padding: 0 10px;
  }
  input{
    position: relative;
    z-index: 1;
    padding-left: 25px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/RsvpDetails/index2.vue